
import React, { useState, useRef, useEffect, useContext } from 'react';
import { DynamicHeightImage } from './DynamicHeightImage';
import ProfilesDisplaySharePost from './ProfilesDisplaySharePost';
import { AppContext } from './AppContext';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getAuth } from "firebase/auth";
import { firestore } from './firebase';
import { getFirestore, runTransaction, arrayRemove, writeBatch, deleteField, deleteDoc, increment, addDoc, setDoc, serverTimestamp, doc, getDoc, collection, query, where, getDocs, orderBy, updateDoc, startAfter, limit, arrayUnion } from 'firebase/firestore';
import { useLocation, useNavigate } from 'react-router-dom';
import LikeIcon from './assets/LikeIcon.png'; // Import the image
import LikeIconActive from './assets/LikeIconActive.png'; // Import the active image
import CommentIcon from './assets/CommentIcon.png'; // Import other icons similarly
import RepostIcon from './assets/RepostIcon.png';
import RepostIconActive from './assets/RepostIconActive.png';
import ellipsis from './assets/ellipsis-v.png';
import Modal from 'react-modal';
import { ProfilesDisplayShareDATpost } from './ProfilesDisplayShareDATpost';
import { SharePostPopup } from './SharePostPopup';
import { FaEye, FaPaperPlane } from 'react-icons/fa';
import { IoVolumeHigh, IoVolumeMuteOutline, IoMusicalNotesOutline } from 'react-icons/io5';

const { width, height } = { width: window.innerWidth, height: window.innerHeight };

const bottomAreaHeight = height * 0.21;
const horizontalAreaSpacing = height * 0.015;
const scrollAreaTopPadding = height * 0.17;

const CACHE_DURATION = 1;


const ViewPostScreen = ({onMoveMP, onProfilePress}) => {

  const navigate = useNavigate();
  const location = useLocation();
  const { isLiked: initialLiked, isReposted: initialReposted, isOriginalFromRepost } = location.state;
const [post, setPost] = useState(location.state.post);
  const commentTargetPostId = post?.postId ?? post?.id;

  const { 
sharePostActive, showSharePostPopup, setShowSharePostPopup, setMyPosts, setAllPosts,
showMediaPopup, currentUser, setPostToShare, setSharePostActive, setCurrentlyLoadingProfile, setActivePopupMedia, activePopupMedia, setTrackToView, setIsExpandedShare, setIsLoadingHideEA, setInitiallySelectedItemId, setActiveTab, setIsExpanded, setIsLoadingArtwork, setIsLoadingProfilePicture, setIsLoadingExpand, setIsLoadingNewPopup, setArtworkUri, setInitialExpandedAlbumAndSong, setCenteredRelease, setHideExpandedAlbum, likes, userId2, setLikes, setPosts, reposts, setReposts,
addViewedVideo, posts, activeMedia, setUserPosts

} = useContext(AppContext);

const unsyncedMineRef = useRef([]);



useEffect(() => {
  
}, [location.state]);



useEffect(() => {

}, [post]);




const [isSelecting, setIsSelecting] = useState(false);
const [isLoading, setIsLoading] = useState(false);

const [modalVisibleVideo, setModalVisibleVideo] = useState(false);
const [modalVisible, setModalVisible] = useState(false);
const [currentImage, setCurrentImage] = useState(null);

  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');

const [localRepostCount, setLocalRepostCount] = useState(post.repostCount);

  const [localLikeCount, setLocalLikeCount] = useState(post.likeCount || 0);

  const [localCommentCount, setLocalCommentCount] = useState(post.commentCount || 0);

  const [isLiked, setIsLiked] = useState(likes[post.id] || false)
  const [isReposted, setIsReposted] = useState(initialReposted);

const [activeCommentId, setActiveCommentId] = useState(null);
const [replyText, setReplyText] = useState("");

const [replyTexts, setReplyTexts] = useState({});

  const [activeItemId, setActiveItemId] = useState(null);

const createKey = (userId, index) => `${userId}_${index}`;


const [visibleReplies, setVisibleReplies] = useState({});

const [loadedCommentCount, setLoadedCommentCount] = useState(10); // Load 10 comments initially
const [hasMoreComments, setHasMoreComments] = useState(true);


const [comment, setComment] = useState("");
const [searchResultsComments, setSearchResultsComments] = useState([]);
const [isSearchingComments, setIsSearchingComments] = useState(false);

const [searchResultsReplies, setSearchResultsReplies] = useState([]);
const [isSearchingReplies, setIsSearchingReplies] = useState(false);
const [tags, setTags] = useState([]);
    const commentInputRef = useRef(null);
const [selection, setSelection] = useState({ start: 0, end: 0 });


const [replyTags, setReplyTags] = useState({});
    const replyInputRef = useRef(null);
const [selectionReplies, setSelectionReplies] = useState({ start: 0, end: 0 });
const textInputRef = useRef();


const [nestedReplyTexts, setNestedReplyTexts] = useState({});
const [nestedReplyTags, setNestedReplyTags] = useState({});

const videoRefs = useRef({});
  const videoRef = useRef(null);

const [currentVideoUri, setCurrentVideoUri] = useState(null);

const bumpCommentCountEverywhere = (targetId, delta = 1) => {
  setLocalCommentCount(c => Math.max((c || 0) + delta, 0));
  const bump = p =>
    (p.id === targetId || p.postId === targetId)
      ? { ...p, commentCount: Math.max((p.commentCount || 0) + delta, 0) }
      : p;

  setPosts(prev => prev.map(bump));
  setMyPosts(prev => prev.map(bump));
  setAllPosts(prev => prev.map(bump));
};

const syncSummaryCommentCount = async (targetId, delta = 1) => {
  const db = getFirestore();
  const summariesRef = collection(db, 'socialSummaries');
  const newestSnap = await getDocs(query(summariesRef, orderBy('__name__', 'desc'), limit(1)));
  if (newestSnap.empty) return;

  const docRef = newestSnap.docs[0].ref;
  const data = newestSnap.docs[0].data() || {};
  const postsArr = (data.posts || []).map(p =>
    p.postId === targetId
      ? { ...p, commentCount: Math.max((p.commentCount || 0) + delta, 0) }
      : p
  );
  await updateDoc(docRef, { posts: postsArr });
};


  const handleFullscreenUpdate = (event) => {
    
    if (event.fullscreenUpdate === 3) {  // FULLSCREEN_UPDATE_PLAYER_DID_DISMISS
      
      setModalVisibleVideo(false);  // Close the modal after fullscreen is completely exited
    }
  };


useEffect(() => {
  const searchUsers = async (queryText) => {
    const lastAtPos = queryText.lastIndexOf("@");
    if (lastAtPos === -1) {
      setIsSearchingComments(false);
      setSearchResultsComments([]);
      return;
    }

    const searchQuery = queryText.substring(lastAtPos + 1);
    if (searchQuery.length > 0) {
      setIsSearchingComments(true);
      const searchValue = searchQuery.toLowerCase();
      const usersRef = collection(firestore, 'users');
      const q = query(
        usersRef, 
        where('username_lower', '>=', searchValue),
        where('username_lower', '<=', searchValue + '\uf8ff'),
        limit(3)
      );

      try {
        const querySnapshot = await getDocs(q);
        const users = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setSearchResultsComments(users);
      } catch (error) {
        console.error("Error searching users:", error);
        setSearchResultsComments([]);
      }
    } else {
      setIsSearchingComments(false);
      setSearchResultsComments([]);
    }
  };

  if (comment.includes("@")) {
    const delayDebounce = setTimeout(() => {
      searchUsers(comment);
    }, 300);

    return () => clearTimeout(delayDebounce);
  }
}, [comment]);


useEffect(() => {
  const searchUsers = async (queryText, commentId) => {
    const lastAtPos = queryText.lastIndexOf("@");
    if (lastAtPos === -1) {
      setIsSearchingReplies(false);
      setSearchResultsReplies([]);
      return;
    }

    const searchQuery = queryText.substring(lastAtPos + 1);
    if (searchQuery.length > 0) {
      setIsSearchingReplies(true);
      const searchValue = searchQuery.toLowerCase();
      const usersRef = collection(firestore, 'users');
      const q = query(
        usersRef, 
        where('username_lower', '>=', searchValue),
        where('username_lower', '<=', searchValue + '\uf8ff'),
        limit(3)
      );

      try {
        const querySnapshot = await getDocs(q);
        const users = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setSearchResultsReplies(users);
      } catch (error) {
        console.error("Error searching users in replies:", error);
        setSearchResultsReplies([]);
      }
    } else {
      setIsSearchingReplies(false);
      setSearchResultsReplies([]);
    }
  };

  // Assuming `replyTexts` is a state tracking all replies' texts
  Object.entries(replyTexts).forEach(([commentId, text]) => {
    if (text.includes("@")) {
      const delayDebounce = setTimeout(() => {
        searchUsers(text, commentId);
      }, 300);

      return () => clearTimeout(delayDebounce);
    }
  });
}, [replyTexts]);




const handleSelectUser = (user) => {
    const cursorPosition = selection.start;
    const lastAtPos = comment.lastIndexOf("@", cursorPosition);

    const beforeAt = comment.substring(0, lastAtPos);
    const afterAt = comment.substring(cursorPosition);

    const newComment = `${beforeAt}@${user.username} ${afterAt}`;
    setComment(newComment);

    const newTag = {
        username: user.username,
        userId: user.id,
        start: beforeAt.length + 1,  // +1 for '@'
        end: beforeAt.length + 1 + user.username.length
    };

    const updatedTags = [...tags.filter(tag => tag.end <= lastAtPos), newTag].sort((a, b) => a.start - b.start);
    setTags(updatedTags);

    setIsSearchingComments(false);
    setSearchResultsComments([]);

    // Set cursor position right after the newly inserted tag
    const newCursorPos = beforeAt.length + user.username.length + 2; // +2 for '@' and space
    setSelection({ start: newCursorPos, end: newCursorPos });
};



const handleSelectUserForReply = (user, commentId) => {
    const cursorPosition = selectionReplies.start;  // Using reply-specific selection state
    const replyText = replyTexts[commentId] || '';
    
    // Find the position of the last "@" before the cursor to replace the entire mention query
    const lastAtPos = replyText.lastIndexOf("@", cursorPosition);
    const endOfMentionPos = replyText.indexOf(' ', lastAtPos);
    const beforeAt = replyText.substring(0, lastAtPos);
    const afterAt = endOfMentionPos > -1 ? replyText.substring(endOfMentionPos) : '';

    // Construct new reply text by inserting the full username tag at the last "@" position
    const newReplyText = `${beforeAt}@${user.username} ${afterAt}`;
    setReplyTexts(prev => ({ ...prev, [commentId]: newReplyText }));

    const newTag = {
        username: user.username,
        userId: user.id,
        start: beforeAt.length + 1,  // +1 for '@'
        end: beforeAt.length + 1 + user.username.length
    };

    // Update replyTags for the specific commentId
    const updatedReplyTags = [...(replyTags[commentId] || []).filter(tag => tag.end <= lastAtPos), newTag].sort((a, b) => a.start - b.start);
    setReplyTags(prev => ({ ...prev, [commentId]: updatedReplyTags }));

    setIsSearchingReplies(false);
    setSearchResultsReplies([]);

    // Set cursor position right after the newly inserted tag
    const newCursorPos = beforeAt.length + user.username.length + 2; // +2 for '@' and space
    setSelectionReplies({ start: newCursorPos, end: newCursorPos });
};





const handleTextChange = (event) => {
  const text = event.target.value;
  setComment(text);

  if (text.lastIndexOf("@") > (tags.length > 0 ? Math.max(...tags.map(tag => tag.end)) : -1)) {
    setIsSearchingComments(true);
  } else {
    setIsSearchingComments(false);
  }

  // Update tag positions based on text editing
  const adjustedTags = tags.map(tag => {
    if (text.substring(tag.start, tag.end) === `@${tag.username}`) {
      return tag;  // Tag is unchanged
    } else {
      // Find the new position if the username still exists in text
      const startPos = text.indexOf(`@${tag.username}`);
      if (startPos !== -1) {
        return { ...tag, start: startPos, end: startPos + tag.username.length + 1 };
      }
    }
    return null;  // Tag no longer valid
  }).filter(tag => tag !== null);

  setTags(adjustedTags);

  
};








const updateTagsBasedOnText = (text) => {
  

  // Parse current text to find all tags
  const currentTags = parseTagsFromText(text);

  // Update the tags state
  
  setTags(currentTags);
};


const parseTagsFromText = (text) => {
  
  // Adjust regex to match tags followed directly by any characters
  const tagRegex = /@(\w+)\{(\w+)\}/g;
  let match;
  const foundTags = [];

  while ((match = tagRegex.exec(text)) !== null) {
    const username = match[1];
    const userId = match[2];
    foundTags.push({ username, userId });
    
  }

  return foundTags;
};





useEffect(() => {
  const fetchComments = async () => {
    if (!commentTargetPostId) return;

    const db = getFirestore();
    const commentsRef = collection(db, 'posts', commentTargetPostId, 'comments');

    try {
      const snapshot = await getDocs(commentsRef);
      let commentsData = await Promise.all(snapshot.docs.map(async (docSnap) => {
        const comment = {
          ...docSnap.data(),
          commentId: docSnap.id,
          replies: []
        };

        const repliesRef = collection(db, 'posts', commentTargetPostId, 'comments', docSnap.id, 'replies');
        const replySnapshot = await getDocs(repliesRef);
        const replies = replySnapshot.docs.map(replyDoc => ({
          ...replyDoc.data(),
          replyId: replyDoc.id
        }));

        replies.sort((a, b) => b.createdAt.seconds - a.createdAt.seconds);
        comment.replies = replies;
        return comment;
      }));

      commentsData.sort((a, b) => b.createdAt.seconds - a.createdAt.seconds);

      const totalReplies = commentsData.reduce((acc, c) => acc + (c.replies?.length || 0), 0);
      setComments(commentsData);
      setLocalCommentCount(commentsData.length + totalReplies);
    } catch (error) {
      console.error('Error fetching comments and replies:', error);
    }
  };

  fetchComments();
}, [commentTargetPostId]);









const toggleRepliesVisibility = (commentId) => {
  setVisibleReplies(prev => ({
    ...prev,
    [commentId]: !prev[commentId]  // Toggle the visibility
  }));
};




const handleLoadMoreComments = () => {
  if (hasMoreComments) {
    setLoadedCommentCount(prevCount => prevCount + 10);  // Adjust the count as necessary
  }
};




useEffect(() => {
  if (isSelecting && activePopupMedia) {
    onProfilePress(); // Call the function after activePopupMedia has been updated
setCurrentlyLoadingProfile(false);
    setIsSelecting(false);
  }
}, [activePopupMedia]);



const initiateReply = (comment, post) => {

    const replyText = `@${comment.username} `;
    setReplyTexts({ ...replyTexts, [comment.commentId]: replyText });


    const newReplyTag = { username: comment.username, userId: comment.userId };
    setReplyTags({ ...replyTags, [comment.commentId]: [newReplyTag] });

    // Optionally focus on the reply input field
    // replyInputRef.current?.focus();
};



const initiateReplyToReply = (reply, commentId) => {
  const repliesUpdate = comments.map(comment => {
    if (comment.commentId === commentId) {
      return {
        ...comment,
        replies: comment.replies.map(r => {
          if (r.replyId === reply.replyId) {
            return { ...r, isReplying: !r.isReplying };  // Toggle isReplying state
          }
          return r;
        })
      };
    }
    return comment;
  });
  setComments(repliesUpdate);

  // Set the initial reply text with the username tagged for nested reply
  const replyInitialText = `@${reply.username} `;
  setNestedReplyTexts({ ...nestedReplyTexts, [reply.replyId]: replyInitialText });

  // Set the tag for the nested reply
  const newTag = {
    username: reply.username,
    userId: reply.userId,  // Assuming each reply has a userId property
    start: 0,  // Tag starts at the beginning of the text
    end: reply.username.length + 1  // +1 accounts for the '@' symbol
  };
  setNestedReplyTags({ ...nestedReplyTags, [reply.replyId]: [newTag] });

  // Set focus on the input (adjust based on actual input handling)
  setTimeout(() => {
    textInputRef?.current?.focus();
  }, 100);
};





const onReplyToReplySubmit = (replyId, commentId) => {
  
  handleAddNestedReply(replyId, commentId);

};




const onNestedReplySubmit = (replyId, commentId) => {
  setLocalCommentCount(c => (c || 0) + 1);

  const nestedReplyText = nestedReplyTexts[replyId] || '';
  if (!nestedReplyText.trim()) return;

  const userRef = userId2 ? doc(firestore, 'users', userId2) : null;

  const newReply = {
    replyId: doc(collection(getFirestore(), 'posts', commentTargetPostId, 'comments', commentId, 'replies')).id,
    userId: userId2,
    username: currentUser.username,
    name: currentUser.name,
    userRef,
    profileImageUrl: currentUser.profileImageUrl,
    text: nestedReplyText,
    taggedUsers: nestedReplyTags[replyId] || [],
    createdAt: {
      seconds: Math.floor(Date.now() / 1000),
      nanoseconds: 0,
    },
    isReplying: false
  };

  // Optimistic UI for nested reply + toggle reply state
  setNestedReplyTexts(prev => ({ ...prev, [replyId]: '' }));
  setComments(curr => curr.map(c => {
    if (c.commentId === commentId) {
      return {
        ...c,
        replies: [newReply].concat(
          c.replies.map(r => (r.replyId === replyId ? { ...r, isReplying: false } : r))
        )
      };
    }
    return c;
  }));
  setNestedReplyTags(prev => ({ ...prev, [replyId]: [] }));

  // Optimistically bump the commentCount in all local lists for this thread
  const bump = p =>
    (p.id === commentTargetPostId || p.postId === commentTargetPostId)
      ? { ...p, commentCount: (p.commentCount || 0) + 1 }
      : p;

  setPosts(prev => prev.map(bump));
  setMyPosts(prev => prev.map(bump));
  setAllPosts(prev => prev.map(bump));

  // Update socialSummaries (newest -> older) for this thread
  (async () => {
    try {
      const db = getFirestore();
      const summariesRef = collection(db, 'socialSummaries');
      const latestSnap = await getDocs(query(summariesRef, orderBy('__name__', 'desc'), limit(1)));
      if (!latestSnap.empty) {
        let index = parseInt(latestSnap.docs[0].id.split('_')[1], 10);
        for (; index >= 1; index--) {
          const summaryDocRef = doc(db, 'socialSummaries', `summary_${index}`);
          const summarySnap = await getDoc(summaryDocRef);
          if (!summarySnap.exists()) continue;

          const data = summarySnap.data() || {};
          const postsArr = data.posts || [];
          const idx = postsArr.findIndex(p => p.postId === commentTargetPostId);
          if (idx !== -1) {
            postsArr[idx].commentCount = (postsArr[idx].commentCount || 0) + 1;
            await updateDoc(summaryDocRef, { posts: postsArr });
            break;
          }
        }
      }
    } catch (err) {
      console.error('Error updating social summary commentCount for nested reply (web):', err);
    }
  })();

  // Process the addition of the reply asynchronously
  handleAddNestedReply(newReply, replyId, commentId);
};

const handleAddNestedReply = async (newReply, replyId, commentId) => {
  const db = getFirestore();
  const functions = getFunctions();
  const addReply2 = httpsCallable(functions, 'addReply2');

  try {
    const res = await addReply2({
      postId: commentTargetPostId,
      commentId,
      replyId: newReply.replyId,
      userId2,
      replyText: newReply.text,
      replyTags: nestedReplyTags[replyId],
      currentUser
    });

    if (!res?.data?.success) {
      throw new Error('Cloud function execution failed');
    }
  } catch (error) {
    console.error('Error adding nested reply (web):', error);
    rollbackNestedReply(replyId, commentId, newReply);
  }
};



const rollbackNestedReply = (replyId, commentId, newReply) => {
    // Remove the optimistically added reply and restore the previous text
    setNestedReplyTexts(prevTexts => ({ ...prevTexts, [replyId]: newReply.text }));
    setComments(currentComments => currentComments.map(comment => {
        if (comment.commentId === commentId) {
            return {...comment, replies: comment.replies.filter(reply => reply.replyId !== newReply.replyId)};
        }
        return comment;
    }));
};











const handleAddReply = async (commentId) => {
  if (!post || !commentTargetPostId) return;

  const db = getFirestore();
  const replyText = replyTexts[commentId] || '';
  if (!replyText.trim()) return;

  const replyRef = doc(collection(db, 'posts', commentTargetPostId, 'comments', commentId, 'replies'));
  const timestamp = {
    seconds: Math.floor(Date.now() / 1000),
    nanoseconds: 0,
  };

  const userRef = userId2 ? doc(firestore, 'users', userId2) : null;

  const newReply = {
    replyId: replyRef.id,
    userId: userId2,
    username: currentUser.username,
    name: currentUser.name,
    profileImageUrl: currentUser.profileImageUrl,
    text: replyText,
    accountType: currentUser.accountType,
    userRef,
    taggedUsers: replyTags[commentId] || [],
    createdAt: timestamp,
  };

  // Optimistic local updates
  setLocalCommentCount(c => (c || 0) + 1);
  setReplyTexts(prev => ({ ...prev, [commentId]: '' }));
  setComments(currentComments => currentComments.map(c => {
    if (c.commentId === commentId) {
      const updatedReplies = [newReply, ...(c.replies || [])];
      return { ...c, replies: updatedReplies, repliesCount: (c.repliesCount || 0) + 1 };
    }
    return c;
  }));

  const bump = p =>
    (p.id === commentTargetPostId || p.postId === commentTargetPostId)
      ? { ...p, commentCount: (p.commentCount || 0) + 1 }
      : p;

  setPosts(prev => prev.map(bump));
  setMyPosts(prev => prev.map(bump));
  setAllPosts(prev => prev.map(bump));

  // Update socialSummaries (scan newest -> older, bump the matching entry)
  try {
    const summariesRef = collection(db, 'socialSummaries');
    const latestSnap = await getDocs(query(summariesRef, orderBy('__name__', 'desc'), limit(1)));
    if (!latestSnap.empty) {
      let index = parseInt(latestSnap.docs[0].id.split('_')[1], 10);
      for (; index >= 1; index--) {
        const summaryDocRef = doc(db, 'socialSummaries', `summary_${index}`);
        const summarySnap   = await getDoc(summaryDocRef);
        if (!summarySnap.exists()) continue;

        const data     = summarySnap.data() || {};
        const postsArr = data.posts || [];
        const idx      = postsArr.findIndex(p => p.postId === commentTargetPostId);
        if (idx !== -1) {
          postsArr[idx].commentCount = (postsArr[idx].commentCount || 0) + 1;
          await updateDoc(summaryDocRef, { posts: postsArr });
          break;
        }
      }
    }
  } catch (err) {
    console.error('Error updating social summary commentCount for reply:', err);
  }

  // Cloud Function (mirror mobile: use addReply2, pass thread id)
  try {
    const functions = getFunctions();
    const addReply2 = httpsCallable(functions, 'addReply2');
    const addReplyResult = await addReply2({
      postId: commentTargetPostId,
      commentId,
      userId2,
      accountType: currentUser.accountType,
      replyText,
      replyTags: replyTags[commentId],
      currentUser
    });

    if (!addReplyResult.data?.success) {
      throw new Error('Cloud function execution failed');
    }
  } catch (error) {
    console.error('Error adding reply:', error);

    // Rollback local optimistic changes
    setLocalCommentCount(c => Math.max((c || 1) - 1, 0));
    setReplyTexts(prev => ({ ...prev, [commentId]: replyText }));
    setComments(currentComments => currentComments.map(c => {
      if (c.commentId === commentId) {
        return { ...c, replies: (c.replies || []).filter(r => r.replyId !== newReply.replyId) };
      }
      return c;
    }));

    const undo = p =>
      (p.id === commentTargetPostId || p.postId === commentTargetPostId)
        ? { ...p, commentCount: Math.max((p.commentCount || 1) - 1, 0) }
        : p;

    setPosts(prev => prev.map(undo));
    setMyPosts(prev => prev.map(undo));
    setAllPosts(prev => prev.map(undo));

  }
};



function rollbackLocalChangesOnError(commentId, newReply) {
    // Rollback local comment count
    setLocalCommentCount(localCommentCount - 1);

    // Reset reply texts and update comments state
    setReplyTexts({ ...replyTexts, [commentId]: newReply.text });
    setComments(currentComments => currentComments.map(comment => {
        if (comment.commentId === commentId) {
            return { ...comment, replies: comment.replies.filter(reply => reply.replyId !== newReply.replyId) };
        }
        return comment;
    }));
    setPosts(prevPosts => prevPosts.map(p => {
        if (p.id === post.id) {
            return { ...p, commentCount: p.commentCount - 1 };
        }
        return p;
    }));
}






const handleAddComment = async () => {
  let commentRef;

  try {
    if (!post || !commentTargetPostId) return;

    const db = getFirestore();

    // 1) Build comment ref using the *current screen post id* (repost wrapper when applicable)
    const commentsCollection = collection(db, 'posts', commentTargetPostId, 'comments');
    commentRef = doc(commentsCollection);

    const timestamp = {
      seconds: Math.floor(Date.now() / 1000),
      nanoseconds: 0,
    };

    const userRef = userId2 ? doc(firestore, 'users', userId2) : null;
    if (!currentUser) return;
    if (!Array.isArray(tags)) return;

    const commentData = {
      commentId: commentRef.id,
      userId: userId2,
      userRef,
      username: currentUser.username,
      name: currentUser.name,
      profileImageUrl: currentUser.profileImageUrl,
      text: comment,
      accountType: currentUser.accountType,
      taggedUsers: tags,
      createdAt: timestamp,
    };

    // 2) Optimistic local updates (comments list + all post collections)
    setComments(prev => [commentData, ...prev]);
    setLocalCommentCount(c => (c || 0) + 1);
    setNewComment('');
    setComment('');

    setPosts(prev =>
      prev.map(p =>
        (p.id === commentTargetPostId || p.postId === commentTargetPostId)
          ? { ...p, commentCount: (p.commentCount || 0) + 1 }
          : p
      )
    );
    setMyPosts(prev =>
      prev.map(p =>
        (p.id === commentTargetPostId || p.postId === commentTargetPostId)
          ? { ...p, commentCount: (p.commentCount || 0) + 1 }
          : p
      )
    );
    setAllPosts(prev =>
      prev.map(p =>
        (p.id === commentTargetPostId || p.postId === commentTargetPostId)
          ? { ...p, commentCount: (p.commentCount || 0) + 1 }
          : p
      )
    );

    // 3) Cloud Function (use addComment2 like mobile)
    const functions = getFunctions();
    const addComment = httpsCallable(functions, 'addComment2');

    await addComment({
      postId: commentTargetPostId,
      userId2,
      comment,
      accountType: currentUser.accountType,
      tags,
      currentUser,
      commentId: commentRef.id
    });

    // 4) Update socialSummaries (scan newest to older until the doc containing this post is found)
    try {
      const summariesRef = collection(db, 'socialSummaries');
      const latestSnap = await getDocs(query(summariesRef, orderBy('__name__', 'desc'), limit(1)));
      if (!latestSnap.empty) {
        const latestId = latestSnap.docs[0].id; // e.g., "summary_3"
        const parts = latestId.split('_');
        let index = parseInt(parts[1], 10);

        for (; index >= 1; index--) {
          const summaryDocRef = doc(db, 'socialSummaries', `summary_${index}`);
          const summarySnap = await getDoc(summaryDocRef);
          if (!summarySnap.exists()) continue;

          const data = summarySnap.data() || {};
          const postsArr = data.posts || [];
          const idx = postsArr.findIndex(p => p.postId === commentTargetPostId);

          if (idx !== -1) {
            postsArr[idx].commentCount = (postsArr[idx].commentCount || 0) + 1;
            await updateDoc(summaryDocRef, { posts: postsArr });
            break;
          }
        }
      }
    } catch (err) {
      console.error('Error updating social summary commentCount sequentially:', err);
    }

  } catch (error) {
    console.error('Error adding comment:', error);

    // Roll back optimistic updates if we created a local placeholder
    if (commentRef?.id) {
      setComments(prev => prev.filter(c => c.commentId !== commentRef.id));
      setLocalCommentCount(c => Math.max((c || 1) - 1, 0));

      const undo = p =>
        (p.id === commentTargetPostId || p.postId === commentTargetPostId)
          ? { ...p, commentCount: Math.max((p.commentCount || 1) - 1, 0) }
          : p;

      setPosts(prev => prev.map(undo));
      setMyPosts(prev => prev.map(undo));
      setAllPosts(prev => prev.map(undo));
    }
  }
};
















const sortReleasesByTimestampSHARE = (releases) => {
  const sortedReleases = [...releases].sort((a, b) => b.releaseTimestamp - a.releaseTimestamp);

  return sortedReleases;
};



const handlePressBeginsSHARE = async (song) => {
  const clonedSong = JSON.parse(JSON.stringify(song));
  navigate(`/dat/${song.contentId}`, { state: { clonedSong } });
};

const updateSongWithProfileData = async (profileData, song) => {
  const { singles = [], albums = [], videos = [] } = profileData;
  const allReleases = [...singles, ...albums, ...videos];
  const matchedSong = allReleases.find(release => release.contentId === song.contentId);
  
  if (matchedSong) {
    song.ArtistName = matchedSong.ArtistName || song.ArtistName;
    song.SongName = matchedSong.SongName || song.SongName;
    song.albumName = matchedSong.albumName || song.albumName;
    song.producers = matchedSong.producers || song.producers;
    song.songwriters = matchedSong.songwriters || song.songwriters;
    song.recordLabels = matchedSong.recordLabels || song.recordLabels;
    song.VideoURL = matchedSong.VideoURL || song.VideoURL;
    song.ArtworkURL = matchedSong.ArtworkURL || song.ArtworkURL;
    return matchedSong;
  }
  return song;
};






const preparePopupDataSHARE = (song, userData) => {
  let profileImageUrl = null;
  const itemUserData = [];


    profileImageUrl = userData.profileImageUrl || null;


  let userAlbums = sortReleasesByTimestampSHARE(userData.albums || []);
  let userSingles = sortReleasesByTimestampSHARE(userData.singles || []);
  let userVideos = sortReleasesByTimestampSHARE(userData.videos || []);

  let selectedAlbum = userAlbums.find(album => album.contentId === song.contentId) || null;
  let selectedSingle = userSingles.find(single => single.contentId === song.contentId) || null;
  let selectedVideo = userVideos.find(video => video.contentId === song.contentId) || null;


  const artworkUri = selectedVideo?.VideoThumbnailURL || (selectedAlbum || selectedSingle)?.ArtworkURL || song?.ArtworkURL;
  setArtworkUri(artworkUri);

  let dimensions = [];
  if (song.isVideo) {
    dimensions = song.dimensions || [];
  }

  if (selectedAlbum && selectedAlbum.songs.length > 0) {
    setInitialExpandedAlbumAndSong(selectedAlbum, selectedAlbum.songs[0]);
    setCenteredRelease(selectedAlbum);
  } else if (selectedSingle && selectedSingle.length > 0) {
    setCenteredRelease(selectedSingle);
  } else if (selectedVideo) {
    setCenteredRelease(selectedVideo);
  }

  const songName = song.isVideo ? song.VideoName : song.SongName;

  return {
    url: song.SongURL,
    dimensions: dimensions,
    isVideo: song.isVideo,
    artistName: song.ArtistName,
    popupProfileImage: userData?.profileImageUrl,
    username: song.username,
    songName: songName,
    artworkUrl: artworkUri,
    contentId: song.contentId,
    localArtworkURL: song.localArtworkURL,
    userId: song.artistUserId,
    isAlbum: song.isAlbum,
    albumName: selectedAlbum?.albumName || '',
    producers: song.producers,
    songwriters: song.songwriters,
    recordLabels: song.recordLabels,
    otherReleases: { albums: userAlbums, singles: userSingles, videos: userVideos },
    albumSongs: selectedAlbum?.songs || [],
    single: selectedSingle,
    video: selectedVideo,
    timestamp: new Date().getTime(),
    vocalDrop: userData.vocalDrop,
    bio: userData.bio,
    blurb: userData.blurb,
    location: userData.location,
    ScreenSKN: userData.ScreenSKN,
  };
};






const getCachedUserDocSHARE = async (userId) => {
  let userDataCached = [];
  let userDataCachedNew = [];
    
    const userDocRef = doc(firestore, 'users', userId);
    const userDocSnap = await getDoc(userDocRef);

    if (userDocSnap.exists()) {
      
      const freshUserData = userDocSnap.data();

      



      // Update userDataCached structure with fresh data and timestamp, keep old local URLs initially.
      userDataCachedNew = {
        ...freshUserData, // overwrite with fresh data from Firestore
        profileImageUrl: freshUserData.profileImageUrl,
      };



      // Persist any updates in the cache and database

    } else {
      console.error(`[getCachedUserDoc] No document found in Firestore for userId: ${userId}`);
    }
  

  return userDataCachedNew;
};











useEffect(() => {
  
  const fetchPostData = async () => {
    
    const db = getFirestore();
    const postRef = doc(db, 'posts', post.id);
    const postSnap = await getDoc(postRef);

    if (postSnap.exists()) {
      const postData = postSnap.data();
      
      updatePostInView(postData);
    } else {
      
    }
  };

  if (isOriginalFromRepost) {
    fetchPostData();
  }
}, [isOriginalFromRepost]);  // Ensure the right dependencies are here

  const updatePostInView = (postData) => {
    setLocalRepostCount(postData.repostCount || 0);
    setLocalLikeCount(postData.likeCount || 0);
    
    // Maintain the user's interaction unless data clearly updates it
  setIsLiked(prev => postData.likes[currentUser.userId] ?? prev);
    setIsReposted(!!postData.reposts && !!postData.reposts[currentUser?.userId]);

    setPosts(prevPosts =>
      prevPosts.map(p => (p.id === postData.id ? { ...p, ...postData } : p))
    );
  };


  const handlePressOriginalPost = (originalPost) => {
    navigate('/viewpost', {
      state: {
        post: originalPost,
        profileImageUrl: originalPost.profileImageUrl,
        key: originalPost.id,
        isLiked: !!likes[originalPost.id],
        isReposted: !!reposts[originalPost.id],
        isOriginalFromRepost: true
      }
    });
  };


  const handleRepost = async (post, newUserText = '', newUserImageUri = '') => {
  
    const db         = getFirestore();
    const currentUid = userId2;                       // our uid from context
    if (!currentUid || !post || !currentUser) return;
  
    let isUnrepost          = false;
    let deletedRepostId     = null;
    let newRepostData       = null;
    let updatedRepostCount  = 0;
  
    /* which post are we (un)reposting? */
    const targetPostId = post.originalPost ? post.originalPost.postId : post.postId;
    const originalRef  = doc(db, 'posts', targetPostId);
    const summaryRef   = doc(db, 'socialSummaryReposts', currentUid);
  
    /* ---------- helpers for optimistic UI ---------- */
    const bumpCount = (setter, delta) =>
      setter(arr => arr.map(p =>
        p.postId === targetPostId
          ? { ...p, repostCount: Math.max((p.repostCount || 0) + delta, 0) }
          : p
      ));
  
    const addRepost  = (setter, item) => setter(arr => [item, ...arr]);
    const dropRepost = (setter, rid)  => setter(arr => arr.filter(p => p.postId !== rid));
  
    try {
      await runTransaction(db, async (tx) => {
        /* 1️⃣  read data we need (original may no longer exist) */
        const [origSnap, sumSnap] = await Promise.all([
          tx.get(originalRef),
          tx.get(summaryRef)
        ]);
  
        const originalExists = origSnap.exists();
        const originalData   = originalExists ? origSnap.data() : null;
        const summaryData    = sumSnap.exists() ? sumSnap.data() : { reposts: {} };
  
        const existingId     = summaryData.reposts[targetPostId];
        const alreadyShared  = !!existingId;
  
        /* ===================================================
           UN-REPOST
           =================================================== */
        if (alreadyShared) {
          const repostId = existingId || post.postId;   // fallback if map is stale
  
          /* firestore */
          tx.delete(doc(db, 'posts', repostId));
          tx.update(summaryRef, {
            [`reposts.${targetPostId}`]: deleteField()
          });
  
          /* update counter only if original still exists */
          let newCount = 0;
          if (originalExists) {
            newCount = Math.max((originalData.repostCount || 1) - 1, 0);
            tx.update(originalRef, {
              repostCount:    newCount,
              repostUserIds:  arrayRemove(currentUid)
            });
          }
  
          /* optimistic UI */
          bumpCount(setPosts,      -1);
          bumpCount(setMyPosts,    -1);
          bumpCount(setAllPosts, -1);
          dropRepost(setPosts,     repostId);
          dropRepost(setMyPosts,   repostId);
          dropRepost(setAllPosts, repostId);

          const fixOriginal = p =>
            p.postId === targetPostId
              ? {
                  ...p,
                  repostCount   : Math.max((p.repostCount || 1) - 1, 0),
                  repostUserIds : (p.repostUserIds || []).filter(uid => uid !== currentUid)
                }
              : p;
          
          setPosts   (arr => arr.map(fixOriginal));
          setMyPosts (arr => arr.map(fixOriginal));
          setAllPosts(arr => arr.map(fixOriginal));
          
          unsyncedMineRef.current =
            unsyncedMineRef.current.map(fixOriginal);
          

          unsyncedMineRef.current =
    unsyncedMineRef.current.filter(p => p.postId !== repostId);
  
          setReposts(prev => {
            const out = { ...prev };
            delete out[targetPostId];
            return out;
          });
  
          /* expose flags for summary-doc maintenance */
          isUnrepost          = true;
          deletedRepostId     = repostId;
          updatedRepostCount  = newCount;
          return;   // transaction work finished
        }
  
        /* ===================================================
           CREATE REPOST  (only if original still exists)
           =================================================== */
        if (!originalExists) throw new Error('Original post missing – cannot repost');
  
        const repostRef  = doc(collection(db, 'posts'));
  
        /* local object for instant rendering */
        const localRepost = {
          postId        : repostRef.id,
          text          : newUserText,
          imageUri      : newUserImageUri,           // may be '' but never undefined
          userId        : currentUid,
          accountType   : currentUser.accountType,
          username      : currentUser.username,
          name          : currentUser.name,
          profileImageUrl : currentUser.profileImageUrl,
          createdAt     : Date.now(),
          originalPost  : {
            postId       : originalData.postId,
            id           : targetPostId,
            userId       : originalData.userId,
            imageWidth   : originalData.imageWidth ?? '1',
            imageHeight  : originalData.imageHeight ?? '1',
            username     : originalData.username,
            name         : originalData.name,
            tags         : originalData.tags ?? [],
            mediaType    : originalData.mediaType ?? '',
            profileImageUrl: originalData.profileImageUrl,
            text         : originalData.text,
            ...(originalData.imageUri    && { imageUri   : originalData.imageUri }),
            ...(originalData.accountType && { accountType: originalData.accountType }),
            ...(originalData.userRef     && { userRef    : originalData.userRef }),
            ...(originalData.profile     && { profile    : originalData.profile }),
            ...(originalData.media       && { media      : originalData.media }),
          },
          likeCount      : 0,
          repostCount    : 0,
          likes          : {},
          comments       : [],
          repostUserIds  : [],
        };
  
        /* firestore copy */
        tx.set(repostRef, { ...localRepost, createdAt: serverTimestamp() });
  
        /* update summary map */
        summaryData.reposts[targetPostId] = repostRef.id;
        tx.set(summaryRef, summaryData, { merge: true });
  
        /* bump original counter */
        const newCount = (originalData.repostCount || 0) + 1;
        tx.update(originalRef, {
          repostCount:    newCount,
          repostUserIds:  arrayUnion(currentUid),
        });
  
        /* optimistic UI */
        bumpCount(setPosts,      +1);
        bumpCount(setMyPosts,    +1);
        addRepost(setPosts,      localRepost);
        addRepost(setMyPosts,    localRepost);
  
        setReposts(prev => ({ ...prev, [targetPostId]: true }));
  
        /* expose for summary-doc section */
        newRepostData       = localRepost;
        updatedRepostCount  = newCount;
      });
  
      /* ========== summary-doc maintenance (outside tx) ========== */
      const summariesRef = collection(db, 'socialSummaries');
      const newestSnap   = await getDocs(
        query(summariesRef, orderBy('__name__', 'desc'), limit(1))
      );
  
      let summaryDocRef, summaryData;
      if (!newestSnap.empty) {
        summaryDocRef = newestSnap.docs[0].ref;
        summaryData   = newestSnap.docs[0].data();
      } else {
        summaryDocRef = doc(summariesRef, 'summary_1');
        summaryData   = { posts: [], sizeEstimate: 0 };
      }
  
      let postsArr = summaryData.posts || [];
      let changed  = false;
  
      /* sync counter on original IF original still exists */
      postsArr = postsArr.map(p => {
        if (p.postId !== targetPostId) return p;
      
        const withoutMe = (p.repostUserIds || []).filter(uid => uid !== currentUid);
      
        return {
          ...p,
          repostCount   : updatedRepostCount,   // 0 after an unre-post
          repostUserIds : withoutMe
        };
      });
      
  
      if (isUnrepost) {
        const before = postsArr.length;
        postsArr = postsArr.filter(p => p.postId !== deletedRepostId);
        changed |= before !== postsArr.length;
      } else if (newRepostData) {
        const exists = postsArr.some(p => p.postId === newRepostData.postId);
        if (!exists) {
          const est       = 200 + new TextEncoder().encode(JSON.stringify(newRepostData)).length;
          const threshold = 950000;
          if ((summaryData.sizeEstimate || 0) + est > threshold) {
            /* document full – create a new one */
            const parts     = summaryDocRef.id.split('_');
            const nextIndex = parts.length === 2 ? parseInt(parts[1], 10) + 1 : 1;
            await setDoc(doc(summariesRef, `summary_${nextIndex}`), {
              posts: [{ ...newRepostData, createdAt: Date.now(), repostCount: updatedRepostCount }],
              sizeEstimate: est,
            });
          } else {
            postsArr.push({
              ...newRepostData,
              createdAt: Date.now(),
              repostCount: updatedRepostCount
            });
            summaryData.sizeEstimate = (summaryData.sizeEstimate || 0) + est;
            changed = true;
          }
        }
      }
  
      if (changed) {
        await updateDoc(summaryDocRef, {
          posts:        postsArr,
          sizeEstimate: summaryData.sizeEstimate || 0
        });
      }
    } catch (err) {
      console.error('❌ handleRepost failed:', err);
    }
  };














const handleProfileSelect = async (profileData, userId) => {


  try {
    setIsSelecting(true);
    const popupData = preparePopupData(profileData, userId);
    setActivePopupMedia(popupData); // This triggers the useEffect
  } catch (error) {
setCurrentlyLoadingProfile(false);
    console.error('Error in handleProfileSelect:', error);
  }
};









const sortReleasesByTimestamp = (releases) => {
  const sortedReleases = [...releases].sort((a, b) => b.releaseTimestamp - a.releaseTimestamp);

  return sortedReleases;
};

const preparePopupData = (userData, userId) => {
  
   
   
  const albums = sortReleasesByTimestamp(userData.albums || []);
  const singles = sortReleasesByTimestamp(userData.singles || []);
  const videos = sortReleasesByTimestamp(userData.videos || []);

  let profileImageUrl = null;


    profileImageUrl = userData?.profileImageUrl || null;


  const popupData = {
    artistName: userData.artistName || userData.ArtistName,
    popupProfileImage: userData?.profileImageUrl,
    username: userData.username,
    accountType: userData.accountType,
    userId: userId,
    otherReleases: { albums, singles, videos },
    vocalDrop: userData.vocalDrop,
    voiceDropMuted: userData?.voiceDropMuted,
    bio: userData.bio,
    blurb: userData.blurb,
    location: userData.location,
    timestamp: new Date().getTime(),
    ScreenSKN: userData.ScreenSKN,
  };

  
  return popupData;
};




const getCachedUserDoc = async (userId) => {
  let userDataCached = [];
  let userDataCachedNew = [];
  const now = new Date().getTime();

  if (!userDataCached || now - userDataCached.timestamp >= CACHE_DURATION) {
      
      const userDocRef = doc(firestore, 'users', userId);
      const userDocSnap = await getDoc(userDocRef);

      if (userDocSnap.exists()) {
          
          const freshUserData = userDocSnap.data();

          
          // Update userDataCached structure with fresh data and timestamp
          userDataCachedNew = {
              ...freshUserData, // overwrite with fresh data from Firestore
              profileImageUrl: freshUserData?.profileImageUrl,
              timestamp: now
          };



      } else {
          console.error(`[getCachedUserDoc] No document found in Firestore for userId: ${userId}`);
      }
  } else {
      
      userDataCachedNew = userDataCached;
  }

  return userDataCachedNew;
};




const fetchUserProfileByUsername = async (username) => {
  if (!username) return;

setCurrentlyLoadingProfile(true);

  try {
    const q = query(collection(firestore, 'users'), where('username_lower', '==', username.toLowerCase()));
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      const doc = querySnapshot.docs[0];
      const userData = await getCachedUserDoc(doc.id);

      if (userData) {
        handleProfileSelect(userData, doc.id);
      } else {
        console.error(`UserData could not be prepared for username: ${username}`);
      }
    } else {
      console.error(`No user found with username: ${username}`);
    }
  } catch (error) {
    console.error('Error fetching user by username:', error);
setCurrentlyLoadingProfile(false);
  } finally {
    setIsLoading(false);
  }
};





const handleLikePress = async (postId) => {

  const currentUserId = userId2; // already in context
  if (!currentUserId) {
    console.warn('No signed-in user');
    return;
  }

  const db = getFirestore();

    const likeDocRef = doc(db, 'likes', `${currentUserId}_${postId}`);



  const currentItem = (posts || []).find(p => p?.postId === postId);
  if (!currentItem) {
    console.warn('Post not found in local state:', postId);
    return;
  }

  const alreadyLiked = !!(currentItem.likes && currentItem.likes[currentUserId]);


  const newLikesMap = { ...(currentItem.likes || {}) };
  let newLikeCount = currentItem.likeCount || 0;

  if (alreadyLiked) {
    delete newLikesMap[currentUserId];
    newLikeCount = Math.max(newLikeCount - 1, 0);
  } else {
    newLikesMap[currentUserId] = true;
    newLikeCount = newLikeCount + 1;
  }


  const bumpArr = (setter) => setter(arr => {
    if (!Array.isArray(arr) || arr.length === 0) return arr;
    const copy = [...arr];
    const idx = copy.findIndex(p => p?.postId === postId);
    if (idx === -1) return arr;

    const p = { ...copy[idx] };
    p.likes = newLikesMap;
    p.likeCount = newLikeCount;

    copy[idx] = p;
    return copy;
  });


  bumpArr(setPosts);
  bumpArr(setMyPosts);
  bumpArr(setUserPosts);

  if (typeof setPost === 'function') {
  setPost(prev => {
    if (!prev || prev.postId !== postId) return prev;

    const nextLikes = { ...(prev.likes || {}) };
    let nextCount = prev.likeCount || 0;

    if (alreadyLiked) {
      delete nextLikes[currentUserId];
      nextCount = Math.max(nextCount - 1, 0);
    } else {
      nextLikes[currentUserId] = true;
      nextCount = nextCount + 1;
    }

    return { ...prev, likes: nextLikes, likeCount: nextCount };
  });
}


  // --- 2) Persist: find the summary doc that contains this post and update it ---
  try {

    const summariesSnap = await getDocs(collection(db, 'socialSummaries'));

    let targetRef = null;
    let targetPosts = null;
    let idxInArray = -1;

    for (const d of summariesSnap.docs) {
      const data = d.data();
      const arr = Array.isArray(data?.posts) ? data.posts : [];
      const i = arr.findIndex(p => p?.postId === postId);
      if (i !== -1) {
        targetRef = d.ref;
        targetPosts = arr;
        idxInArray = i;
        break;
      }
    }

    if (!targetRef || idxInArray === -1) {
      console.warn('Post not found in any socialSummaries doc:', postId);
      return;
    }


    const updatedPosts = [...targetPosts];
    const updatedPost = { ...updatedPosts[idxInArray] };

    updatedPost.likes = newLikesMap;
    updatedPost.likeCount = newLikeCount;

    updatedPosts[idxInArray] = updatedPost;


    if (alreadyLiked) {
      await deleteDoc(likeDocRef);
    } else {
      await setDoc(likeDocRef, {
        postId,
        userId: currentUserId,
        creatorId: currentItem.userId,      
        name: currentUser?.name || '',
        profileImageUrl: currentUser?.profileImageUrl || '',
        createdAt: serverTimestamp()
      });
    }


    await updateDoc(targetRef, { posts: updatedPosts });
    console.log('Like toggled (summary-only) and saved.');
  } catch (err) {
    console.error('Failed to save like toggle:', err);
    // Optional: revert optimistic UI on error
    const revertArr = (setter) => setter(arr => {
      if (!Array.isArray(arr) || arr.length === 0) return arr;
      const copy = [...arr];
      const idx = copy.findIndex(p => p?.postId === postId);
      if (idx === -1) return arr;

      const p = { ...copy[idx] };
      // revert to prior local values
      const prevLikes = { ...(currentItem.likes || {}) };
      let prevCount = currentItem.likeCount || 0;
      copy[idx] = { ...p, likes: prevLikes, likeCount: prevCount };
      return copy;
    });

    revertArr(setPosts);
    revertArr(setMyPosts);
    revertArr(setUserPosts);
  }
};




function updateLocalStateForRepostDeletion(repostId, originalPostId, updatedRepostCount) {
  setPosts(posts => posts.map(post => {
    if (post.id === originalPostId || post.id === repostId) {
      return { ...post, repostCount: updatedRepostCount };
    }
    return post;
  }));

setLocalRepostCount(localRepostCount - 1);

  // Correctly remove the repost entry from the reposts state
  setReposts(reposts => {
    const updatedReposts = { ...reposts };
    delete updatedReposts[repostId];  // Ensure this matches how reposts are keyed
    delete updatedReposts[originalPostId];  // Also make sure the original post's reference is updated
    return updatedReposts;
  });
}


function updateLocalStateForNewRepost(postId, updatedRepostCount, repostRefId) {

setLocalRepostCount(post.repostCount + 1);
  setPosts(posts => posts.map(post => {
    if (post.id === postId) {
      return { ...post, repostCount: updatedRepostCount };
    }
    return post;
  }));

  // Add the new repost to the reposts state
  setReposts(reposts => ({
    ...reposts,
    [postId]: repostRefId  // This should uniquely identify the repost for UI updates
  }));
}


// Call this function after successful deletion of a repost
const handleRepostDeletion = (postId) => {
  // Find the repostId in the reposts state if it exists
  const repostId = reposts[postId];
  if (repostId) {
    setReposts(reposts => {
      const updatedReposts = { ...reposts };
      delete updatedReposts[postId]; // Remove the repost entry
      return updatedReposts;
    });
  }
}


  const likeIcon = (isOriginalFromRepost ? isLiked : likes[post.id]) 
    ? require('./assets/LikeIconActive.png')
    : require('./assets/LikeIcon.png');


    const handleReplyTextChange = (event, commentId) => {
      const text = event.target.value;
  
    setReplyTexts({ ...replyTexts, [commentId]: text });

    if (text.lastIndexOf("@") > (replyTags[commentId]?.length > 0 ? Math.max(...replyTags[commentId].map(tag => tag.end)) : -1)) {
        setIsSearchingReplies(true); // or another state to manage visibility of user suggestions
    } else {
        setIsSearchingReplies(false);
    }

    const adjustedTags = replyTags[commentId]?.map(tag => {
        if (text.substring(tag.start, tag.end) === `@${tag.username}`) {
            return tag; // Tag is unchanged
        } else {
            const startPos = text.indexOf(`@${tag.username}`);
            if (startPos !== -1) {
                return { ...tag, start: startPos, end: startPos + tag.username.length + 1 };
            }
        }
        return null; // Tag no longer valid
    }).filter(tag => tag !== null) || [];

    setReplyTags({ ...replyTags, [commentId]: adjustedTags });

    
};



const handleReplyTextChangeReplies = (event, replyId) => {
  const text = event.target.value;
    setNestedReplyTexts({ ...nestedReplyTexts, [replyId]: text });

    if (text.lastIndexOf("@") > (nestedReplyTags[replyId]?.length > 0 ? Math.max(...nestedReplyTags[replyId].map(tag => tag.end)) : -1)) {
        setIsSearchingReplies(true); // or another state to manage visibility of user suggestions
    } else {
        setIsSearchingReplies(false);
    }

    const adjustedTags = nestedReplyTags[replyId]?.map(tag => {
        if (text.substring(tag.start, tag.end) === `@${tag.username}`) {
            return tag; // Tag is unchanged
        } else {
            const startPos = text.indexOf(`@${tag.username}`);
            if (startPos !== -1) {
                return { ...tag, start: startPos, end: startPos + tag.username.length + 1 };
            }
        }
        return null; // Tag no longer valid
    }).filter(tag => tag !== null) || [];

    setNestedReplyTags({ ...nestedReplyTags, [replyId]: adjustedTags });

    
};



const onReplySubmit = (commentId) => {
  
  handleAddReply(commentId);
};


const getPid = p => p?.postId || p?.id || '';

const handleDelete = async () => {
  if (!activeItemId) return;

  const { item, type, commentId, postId } = activeItemId;
  const post = item;
  if (post?.originalPost) {
    handleRepost(post);
    return;
  }

  const db = getFirestore();
  let ref = null;

  if (type === 'post') {
    ref = doc(db, 'posts', post.postId);
  } else if (type === 'comment') {
    ref = doc(db, 'posts', postId, 'comments', item.commentId);
  } else if (type === 'reply') {
    ref = doc(db, 'posts', postId, 'comments', commentId, 'replies', item.replyId);
  }

  if (!ref) { console.error('Failed to build Firestore reference for deletion.'); return; }

  try {
    // Figure out how much to decrement BEFORE deleting the doc
    let decrementBy = 0;
    if (type === 'comment') {
      const repliesCol = collection(db, 'posts', postId, 'comments', item.commentId, 'replies');
      const repliesSnap = await getDocs(repliesCol);
      decrementBy = 1 + (repliesSnap?.size || 0); // comment itself + its replies
    } else if (type === 'reply') {
      decrementBy = 1;
    }

    // delete the item itself
    await deleteDoc(ref);

    // EXTRA WORK for ORIGINAL POST deletion (unchanged)
    if (type === 'post') {
      const createdAtMs =
        typeof post.createdAt === "number"
          ? post.createdAt
          : post.createdAt?.toMillis?.() ?? 0;

      const age = Date.now() - createdAtMs;

      const repostIds = [];
      const db = getFirestore();

      const repostsSnap = await getDocs(
        query(collection(db, 'posts'),
              where('originalPost.postId', '==', post.postId))
      );

      if (!repostsSnap.empty) {
        const batch = writeBatch(db);
        repostsSnap.forEach(d => {
          const rid = d.id;
          const uid = d.data().userId;
          repostIds.push(rid);

          batch.delete(d.ref);
          batch.update(
            doc(db, 'socialSummaryReposts', uid),
            { [`reposts.${post.postId}`]: deleteField() }
          );
        });
        await batch.commit();
        console.log(`[delete] also removed ${repostIds.length} repost(s)`);
      }

      const idsGone = new Set([post.postId, ...repostIds]);

      const keep = arr =>
        arr.filter(p =>
          !idsGone.has(getPid(p)) &&
          !idsGone.has(getPid(p.originalPost))
        );

      setPosts(keep);
      setMyPosts(keep);
      setAllPosts(keep);

      unsyncedMineRef.current =
        unsyncedMineRef.current.filter(p => !idsGone.has(getPid(p)));

      const summariesRef = collection(db, 'socialSummaries');
      const newestSnap   = await getDocs(
        query(summariesRef, orderBy('__name__', 'desc'), limit(1))
      );

      if (!newestSnap.empty) {
        let idx        = parseInt(newestSnap.docs[0].id.split('_')[1], 10);
        const overhead = 200;

        while (idx >= 1) {
          const docId   = `summary_${idx}`;
          const docRef  = doc(db, 'socialSummaries', docId);
          const snap    = await getDoc(docRef);
          if (!snap.exists()) { idx--; continue; }

          const data       = snap.data();
          const postsArray = data.posts || [];
          let   changed    = false;

          for (let i = postsArray.length - 1; i >= 0; i--) {
            if (idsGone.has(postsArray[i].postId)) {
              const removed = postsArray.splice(i, 1)[0];
              data.sizeEstimate = Math.max(
                (data.sizeEstimate || 0) -
                (JSON.stringify(removed).length + overhead),
                0
              );
              changed = true;
            }
          }

          if (changed) {
            await updateDoc(docRef, {
              posts:        postsArray,
              sizeEstimate: data.sizeEstimate
            });
          }
          idx--;
        }
      }

      navigate('/social');
    }

    // COMMENT / REPLY EXTRA UPDATES
    if (type === 'comment' || type === 'reply') {
      // Decrement post's commentCount in Firestore
      const postRef = doc(db, 'posts', postId);
      await updateDoc(postRef, { commentCount: increment(-decrementBy) });

      // Update local comments list
      if (type === 'comment') {
        setComments(prev => prev.filter(c => c.commentId !== item.commentId));
      } else if (type === 'reply') {
        setComments(prev => prev.map(c => {
          if (c.commentId === commentId) {
            return {
              ...c,
              replies: (c.replies || []).filter(r => r.replyId !== item.replyId)
            };
          }
          return c;
        }));
      }

      // Update local global state counts across all lists
      const lower = p => {
        if (p.id === postId || p.postId === postId) {
          const next = Math.max((p.commentCount || 0) - decrementBy, 0);
          return { ...p, commentCount: next };
        }
        return p;
      };
      setPosts(prev => prev.map(lower));
      setMyPosts(prev => prev.map(lower));
      setAllPosts(prev => prev.map(lower));

      setLocalCommentCount(cnt => Math.max((cnt || 0) - decrementBy, 0));

      // Decrement in socialSummaries for this post
      (async () => {
        try {
          const summariesRef = collection(db, 'socialSummaries');
          const latestSnap = await getDocs(query(summariesRef, orderBy('__name__', 'desc'), limit(1)));
          if (!latestSnap.empty) {
            let index = parseInt(latestSnap.docs[0].id.split('_')[1], 10);
            for (; index >= 1; index--) {
              const summaryDocRef = doc(db, 'socialSummaries', `summary_${index}`);
              const summarySnap   = await getDoc(summaryDocRef);
              if (!summarySnap.exists()) continue;

              const data     = summarySnap.data() || {};
              const postsArr = data.posts || [];
              const idx      = postsArr.findIndex(p => p.postId === postId);
              if (idx !== -1) {
                postsArr[idx].commentCount = Math.max((postsArr[idx].commentCount || 0) - decrementBy, 0);
                await updateDoc(summaryDocRef, { posts: postsArr });
                break;
              }
            }
          }
        } catch (err) {
          console.error('Error decrementing social summary commentCount:', err);
        }
      })();
    }

    setActiveItemId(null);
  } catch (err) {
    console.error('Error deleting the document:', err);
  }
};




const [reportComplete, setReportComplete] = useState(false);


const handleReport = async (post) => {
  const db = getFirestore();
  const reportRef = doc(collection(db, 'reports'));

  const reportData = {
    reportId: reportRef.id,
    postId: post.id,  // Assuming 'post' has an 'id' field
    text: post.text || '',
    imageUri: post.imageUri || '',
    userId: post.userId,
    username: post.username,
    name: post.name,
    profileImageUrl: post.profileImageUrl,
    createdAt: serverTimestamp(),
    reportedAt: serverTimestamp(),  // Timestamp when the report is created
  };

  try {
    await setDoc(reportRef, reportData);
    
    setReportComplete(true);
  } catch (error) {
    console.error("Error reporting the post: ", error);
  }
};


const handleShare = (post) => {
  setPostToShare(post);
  setSharePostActive(true);
};





const formatDisplayComment = (comment) => {
  return comment.replace(/@\w+\{\w+\}/g, (match) => {
    // Extract just the username part before '{'
    return match.split('{')[0];
  });
};



  const onRefresh = () => {};


  const handleVideoPress = async (videoRef) => {
    if (videoRef) {
      await videoRef.presentFullscreenPlayer();  // This will trigger native fullscreen
      videoRef.setOnPlaybackStatusUpdate(status => {
        if (status.didJustFinish && !status.isLooping) {
          videoRef.dismissFullscreenPlayer(); // Optionally dismiss after playback
        }
      });
    }
  };


  const onModalOpen = () => {
    if (videoRef.current) {
      videoRef.current.playAsync(); // Ensure the video plays when the modal opens
    }
  };



const handleMediaUriTap = (mediaUri, mediaType) => {
  if (mediaType === 'video') {
    setCurrentVideoUri(mediaUri); // Set the current video URI
    setModalVisibleVideo(true);
  } else {
    setModalVisible(true);
    setCurrentImage(mediaUri);
  }
};


const handlePressProfile = (profile) => {
  const clonedProfile = JSON.parse(JSON.stringify(profile));
  const targetRoute = profile.userId === userId2 ? '/mydat/profile' : `/userprofile/${profile.username}`;
  navigate(targetRoute, { state: { profile: clonedProfile, fromURL: false } });
};

const fetchUserProfile = async (userId) => {
  try {
    const userDocRef = doc(firestore, 'users', userId);
    const userDoc = await getDoc(userDocRef);
    if (userDoc.exists()) {
      handlePressProfile(userDoc.data());
    } else {
      
    }
  } catch (error) {
    console.error('Error fetching user profile:', error);
  }
};

const fetchUserProfileByUserId = async (userId) => {
  if (!userId) {
    
    return;
  }

  


  try {
    fetchUserProfile(userId);

  } catch (error) {
    console.error('fetchUserProfileByUserId: Error fetching user by userId:', error);
  } finally {

    setIsLoading(false);
  }
};

const handleVideoError = async (item) => {
  const functions = getFunctions();
  console.error(`Video failed to load for postId: ${item.postId}`);

  // Call the Cloud Function to process the video
  try {
    const convertAndFixVideo = httpsCallable(functions, 'convertFixVideo');

    const result = await convertAndFixVideo({
      postId: item.postId,  // Post ID to update after conversion
      videoUri: item.imageUri,  // Original video URL (that is failing)
      userId: item.userId  // User ID for organizing uploads
    });

    console.log('Cloud Function result:', result.data);

  } catch (error) {
    console.error('Error triggering video conversion Cloud Function:', error);
  }
};





const renderOptions = () => {
  if (!activeItemId) return null;

  const { item, type } = activeItemId;        // renamed for clarity
  const isOwner =
    (type === 'post'    && item.userId === userId2) ||
    (type === 'comment' && item.userId === userId2) ||
    (type === 'reply'   && item.userId === userId2);

  return (
    <div style={styles.optionsContainer} onClick={e => e.stopPropagation()}>
      {isOwner ? (
        <button onClick={e => { e.stopPropagation(); handleDelete(item); }}>Delete</button>
      ) : (
        <button onClick={e => { e.stopPropagation(); handleReport(item); }}>Report</button>
      )}
    </div>
  );
};


const handleToggleOptions = (
  item,
  type,
  parentPostId     = null,  // the post that owns this comment / reply
  parentCommentId   = null   // only for replies
) => {

  const id = type === 'post'
    ? item.postId
    : type === 'comment'
      ? item.commentId
      : item.replyId;

  /* store everything handleDelete still expects */
  const newActive = {
    id,
    type,
    item,           // ← what renderOptions uses
    post: item,     // ← what handleDelete used originally
    postId:  type === 'post'    ? item.postId    : parentPostId,
    commentId: type === 'reply' ? parentCommentId : null
  };

  setActiveItemId(prev =>
    prev && prev.id === id && prev.type === type ? null : newActive
  );
};


const [previewMuted, setPreviewMuted] = useState(true);
const [snippetAudible, setSnippetAudible] = useState(false);   // true when the snippet audio element is playing
const [activeVideoUri, setActiveVideoUri] = useState(null);    // which <video> should be considered "active"
const [isPlaying, setIsPlaying] = useState(false);             // global snippet playing state (parity with RN)
const [isVideoPlaying, setIsVideoPlaying] = useState(false);   // any video currently playing
const [mutedVideos, setMutedVideos] = useState({});            // map<videoUri, boolean>

const globalAudioRef = useRef(new Audio());                    // single audio element for song snippets
const playProgressRef = useRef({});                            // map<postId, {accMs, lastPos, countedInCycle}>
const intersectionRef = useRef(null);                          // IntersectionObserver instance

const VIEW_REQUIREMENT_MS = 5000;                              // 5s view requirement



// Derive a snippet URL similar to RN getItemPreviewURL()
const getItemPreviewURL = (item) => {
  const s = item?.songSnippet || {};
  return (
    s.previewURL || s.PreviewURL || s.SongURL || s.songURL ||
    item?.__parentAlbum?.previewURL || item?.__parentAlbum?.SongURL || ''
  );
};

// Toggle global snippet audio for a specific item
const togglePreviewMuted = (item) => {
  const audio = globalAudioRef.current;
  if (!audio) return;
  const url = getItemPreviewURL(item);
  if (!url) return;

  // If a different snippet is requested while playing, swap source
  const switchingTrack = audio.src !== url;

  if (previewMuted || switchingTrack) {
    audio.src = url;
    audio.currentTime = 0;
    audio.play().then(() => {
      setPreviewMuted(false);
      setSnippetAudible(true);
      setIsPlaying(true);
      // when snippet is audible, keep videos muted
      Object.values(videoRefs.current).forEach(v => v && v.pause());
      setIsVideoPlaying(false);
      setActiveVideoUri(null);
    }).catch(() => {});
  } else {
    audio.pause();
    setPreviewMuted(true);
    setSnippetAudible(false);
    setIsPlaying(false);
  }
};

// Simple per-video mute toggle (for non-snippet videos)
const toggleMute = (uri) => {
  setMutedVideos(prev => {
    const next = { ...prev, [uri]: !(prev[uri] ?? true) };
    const v = videoRefs.current[uri];
    if (v) v.muted = !!next[uri];
    return next;
  });
};

// Register refs for each <video>
const registerVideoRef = (uri, el) => {
  if (!uri) return;
  if (el) {
    videoRefs.current[uri] = el;
  } else {
    delete videoRefs.current[uri];
  }
};




const onPlaybackFor5s = (postId, ownerUserId) => (e) => {
  const el = e.currentTarget; // HTMLVideoElement
  if (!el || !el.duration || isNaN(el.duration)) return;

  // Skip counting if this is the current user's own video
  if (ownerUserId && typeof userId2 === 'string' && ownerUserId === userId2) return;

  // Ignore if paused or not ready
  if (el.paused || el.readyState < 2) return;

  const durMs = Math.max(0, el.duration * 1000);
  const threshold = Math.min(VIEW_REQUIREMENT_MS, durMs);

  const prog = (playProgressRef.current[postId] ||= {
    accMs: 0,
    lastPos: null,
    countedInCycle: false,
  });

  const posMs = Math.max(0, el.currentTime * 1000);

  // Detect loop vs scrub (web approximation of RN logic)
  const movedBackward   = prog.lastPos != null && posMs < prog.lastPos - 1000;     // >1s back
  const nearStart       = posMs <= 750;                                            // ~0.75s
  const wasNearEnd      = prog.lastPos != null && prog.lastPos >= durMs - 1000;    // last tick ~end
  const didLoopLikely   = movedBackward && nearStart && (el.loop === true || wasNearEnd);

  if (didLoopLikely) {
    prog.accMs = 0;
    prog.countedInCycle = false;
  } else if (movedBackward && !nearStart) {
    // user scrubbed backwards mid-video; keep accMs within current position
    prog.accMs = Math.min(prog.accMs, posMs);
  }

  // Accumulate only while actually playing
  if (!el.paused && el.readyState >= 2) {
    if (prog.lastPos != null) {
      const delta = Math.max(0, posMs - prog.lastPos);
      prog.accMs += delta;
    }
  }

  // Short videos: if it finished and duration < threshold, count once
  const ended = el.ended === true || (wasNearEnd && nearStart && movedBackward);
  if (!prog.countedInCycle && ended && durMs < VIEW_REQUIREMENT_MS) {
    prog.countedInCycle = true;
    addViewedVideo(postId);
    bumpLocalView(postId, 1);
  }

  // Normal case: hit the 5s threshold (or duration threshold)
  if (!prog.countedInCycle && prog.accMs >= threshold) {
    prog.countedInCycle = true;
    addViewedVideo(postId);
    bumpLocalView(postId, 1);
  }

  prog.lastPos = posMs;
};
 

// Local UI bump (replace your existing local bump logic with this shape)
const bumpLocalView = (postId, delta = 1) => {
    setPost(prev =>
    prev && prev.postId === postId
      ? { ...prev, viewCount: (prev.viewCount || 0) + delta }
      : prev
  );
  setPosts(prev =>
    prev.map(p => (p.postId === postId ? { ...p, viewCount: (p.viewCount || 0) + delta } : p))
  );
};



useEffect(() => {
  const audio = globalAudioRef.current;
  if (!audio) return;

  const onPlay = () => { setSnippetAudible(true); setIsPlaying(true); };
  const onPause = () => { setSnippetAudible(false); setIsPlaying(false); };
  const onEnded = () => { setSnippetAudible(false); setIsPlaying(false); setPreviewMuted(true); };

  audio.addEventListener('play', onPlay);
  audio.addEventListener('pause', onPause);
  audio.addEventListener('ended', onEnded);

  audio.crossOrigin = 'anonymous';
  audio.preload = 'none';

  return () => {
    audio.removeEventListener('play', onPlay);
    audio.removeEventListener('pause', onPause);
    audio.removeEventListener('ended', onEnded);
  };
}, []);


  useEffect(() => {
  return () => {
    try {
      const a = globalAudioRef.current;
      if (a) { a.pause(); a.src = ''; }
      Object.values(videoRefs.current).forEach(v => v && v.pause());
    } catch {}
  };
}, []);

useEffect(() => {
  if (intersectionRef.current) {
    intersectionRef.current.disconnect();
    intersectionRef.current = null;
  }

  // Don't auto-play videos while a snippet is audible
  if (snippetAudible) {
    Object.values(videoRefs.current).forEach(v => v && v.pause());
    setIsVideoPlaying(false);
    setActiveVideoUri(null);
    return;
  }

  const obs = new IntersectionObserver((entries) => {
    let best = null;
    let bestRatio = 0;

    entries.forEach(entry => {
      const el = entry.target;
      const ratio = entry.intersectionRatio || 0;
      if (ratio > bestRatio) {
        best = el;
        bestRatio = ratio;
      }
    });

    // auto-play the most visible (>= 0.6), pause others
    Object.values(videoRefs.current).forEach(v => {
      if (!v) return;
      if (best && v === best && bestRatio >= 0.6) {
        v.play().then(() => {
          setActiveVideoUri(v.currentSrc || v.src || null);
          setIsVideoPlaying(true);
        }).catch(() => {});
      } else {
        v.pause();
      }
    });
  }, { threshold: [0, 0.25, 0.5, 0.6, 0.75, 1] });

  Object.values(videoRefs.current).forEach(v => v && obs.observe(v));
  intersectionRef.current = obs;

  return () => {
    if (intersectionRef.current) intersectionRef.current.disconnect();
    intersectionRef.current = null;
  };
}, [post, snippetAudible]);


return (
  <div style={styles.fullScreen}>
    <div style={styles.scrollContainer}>
      <div style={styles.postContainer}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={styles.contentRow}>
            <ProfilesDisplaySharePost userProfile={post} onPress={() => fetchUserProfileByUserId(post.userId)} />

            <button
              style={styles.moreInfoButton}
              onClick={e => { e.stopPropagation(); handleToggleOptions(post, 'post'); }}
            >
              <img
                src={ellipsis}
                style={{
                  position: 'relative',
                  bottom: '5px',
                  width: '20px',
                  height: '20px',
                  backgroundColor: 'transparent',
                  zIndex: '50000',
                  pointerEvents: 'auto',
                }}
              ></img>
            </button>
            {activeItemId && activeItemId.id === post.postId    && activeItemId.type === 'post'    && renderOptions()}
          </div>
        </div>

              {post?.songSnippet && (
  <div style={styles.songSnippetRow}>
    <div style={styles.songIconBtn}>
      <IoMusicalNotesOutline size={10} color="#FFFFFF" />
    </div>
    <span style={styles.songSnippetText} title={`${(post.songSnippet.artist || 'Unknown Artist')} - ${(post.songSnippet.name || 'Untitled')}`}>
      {(post.songSnippet.artist || 'Unknown Artist') + ' - ' + (post.songSnippet.name || 'Untitled')}
    </span>
  </div>
)}

        {post?.media ? (
          <div
            onClick={(e) => {
              e.stopPropagation();
              handlePressBeginsSHARE(post.media);
            }}
            style={styles.imageContainer}
          >
            <img src={post.media.ArtworkURL} alt="Media" style={styles.postImage} />
          </div>
        ) : post.imageUri ? (
          <div
            style={post.text ? styles.mediaContainer : { ...styles.mediaContainer, ...styles.additionalMargin }}
          >
            {post.mediaType === 'video' ? (
              <div style={styles.mediaContainer2}>
<video
  ref={(el) => registerVideoRef(post.imageUri, el)}
  src={post.imageUri}
  style={styles.mediaThumbnail2}
  playsInline
  loop
  controls={false}
  muted={post?.songSnippet ? true : (mutedVideos[post.imageUri] ?? true)}
  onTimeUpdate={onPlaybackFor5s(post.postId, post.userId)}
  onClick={(e) => e.stopPropagation()}
  onError={(e) => handleVideoError(post)}
/>
{post?.songSnippet ? (
  <button
    onClick={(e) => { e.stopPropagation(); if ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) return; togglePreviewMuted(post); }}
    style={{ position: 'absolute', right: 8, bottom: 8, zIndex: 5, opacity: ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) ? 0.5 : 1, background: 'transparent', border: 'none', cursor: 'pointer' }}
    aria-label="Toggle snippet audio"
  >
    {previewMuted
      ? <IoVolumeMuteOutline size={24} color="#FFFFFF" />
      : <IoVolumeHigh size={24} color="#FFFFFF" />
    }
  </button>
) : (
  <button
    onClick={(e) => { e.stopPropagation(); toggleMute(post.imageUri); }}
    style={{ position: 'absolute', right: 6, bottom: 6, zIndex: 5, background: 'transparent', border: 'none', cursor: 'pointer' }}
    aria-label="Toggle video mute"
  >
    {(mutedVideos[post.imageUri] ?? true)
      ? <IoVolumeMuteOutline size={24} color="#FFFFFF" />
      : <IoVolumeHigh size={24} color="#FFFFFF" />
    }
  </button>
)}

      </div>
    ) : (
      <img src={post.imageUri} alt="Media" style={styles.postImage} />
      
    )}
    {post?.songSnippet && (
  <button
    onClick={(e) => { e.stopPropagation(); if ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) return; togglePreviewMuted(post); }}
    style={{ position: 'absolute', right: 16, bottom: 36, zIndex: 5, opacity: ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) ? 0.5 : 1, background: 'transparent', border: 'none', cursor: 'pointer' }}
    aria-label="Toggle snippet audio"
  >
    {previewMuted
      ? <IoVolumeMuteOutline size={24} color="#FFFFFF" />
      : <IoVolumeHigh size={24} color="#FFFFFF" />
    }
  </button>
)}

  </div>
) : null}
        {post.text && (
          <p
  style={{
    whiteSpace: 'pre-wrap',  // This preserves both spaces and line breaks.
    ...(post.mediaType === 'video'
      ? styles.postText2
      : post.imageUri
      ? styles.postText
      : styles.postTextNoImage)
  }}
>
  {post.text.split(/(\@\w+)/g).map((part, index) => {
    if (part.startsWith('@') && post.taggedUsers) {
      const userTag = post.taggedUsers.find((tag) => `@${tag.username}` === part);
      if (userTag) {
        return (
          <span
            style={styles.tagContainer}
            key={index}
            onClick={() => fetchUserProfileByUserId(userTag.userId)}
          >
            <span style={{ color: '#62fbfa' }}>{part}</span>
          </span>
        );
      }
    }
    return <span key={index}>{part}</span>;
  })}
</p>
        )}

        {post.profile && (
          <ProfilesDisplaySharePost
            userProfile={post.profile}
            onPress={() => fetchUserProfileByUserId(post.profile.userId)}
          />
        )}

        {post.originalPost && (
          <div
            onClick={() => handlePressOriginalPost(post.originalPost)}
            style={styles.postContainer2}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={styles.contentRow}>
                <ProfilesDisplaySharePost
                  userProfile={post.originalPost}
                  onPress={() => fetchUserProfileByUserId(post.originalPost.userId)}
                />

              </div>
            </div>
            {post.originalPost.media ? (
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  handlePressBeginsSHARE(post.originalPost.media);
                }}
                style={styles.imageContainer}
              >
                <img
                  src={post.originalPost.media.ArtworkURL}
                  alt="Media"
                  style={styles.postImage}
                />
              </div>
            ) : post.originalPost.imageUri ? (
              <div
                style={
                  post.originalPost.text
                    ? styles.mediaContainer
                    : { ...styles.mediaContainer, ...styles.additionalMargin }
                }
              >
                {post.originalPost.mediaType === 'video' ? (
                  <div style={styles.mediaContainer2}>
                    <video
                      src={post.originalPost.imageUri}
                      style={styles.mediaThumbnail2}
                      controls
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                ) : (
                  <img src={post.originalPost.imageUri} alt="Media" style={styles.postImage} />
                )}
              </div>
            ) : null}
{post.originalPost.text && (
  <p
    style={{
      whiteSpace: 'pre-wrap',  // This preserves both spaces and line breaks.
      ...(post.originalPost.imageUri ? styles.postText : styles.postTextNoImage)
    }}
  >
    {post.originalPost.text}
  </p>
)}

          </div>
        )}
        <div style={styles.iconsContainer}>
          <button
            style={styles.iconButtonLike}
            onClick={(e) => {
              e.stopPropagation();
              handleLikePress(post.postId);
            }}
          >
            <div style={styles.likeButtonContainer}>
              <img
                src={post.likes && post.likes[userId2] ? LikeIconActive : LikeIcon}
                alt="Like"
                style={styles.iconImage}
              />
              <span style={styles.likeCount}>
                {isOriginalFromRepost ? localLikeCount : post.likeCount}
              </span>
            </div>
          </button>

          <button style={styles.iconButton}>
            <div style={styles.likeButtonContainer}>
              <img src={CommentIcon} alt="Comment" style={styles.iconImage} />
              <span style={styles.likeCount}>{localCommentCount || 0}</span>
            </div>
          </button>

          {!post.originalPost && (
            <button
              style={styles.iconButton}
              onClick={(e) => {
                e.stopPropagation();
                handleRepost(post);
              }}
            >
              <div style={styles.likeButtonContainer}>
                <img
                  src={
                    reposts[post.id] || (post.originalPost && reposts[post.originalPost.id])
                      ? RepostIconActive
                      : RepostIcon
                  }
                  alt="Repost"
                  style={styles.iconImage}
                />
                <span style={styles.likeCount}>{localRepostCount || 0}</span>
              </div>
            </button>
          )}
                            <button
              style={styles.iconButton}
              onClick={e => { e.stopPropagation(); handleShare(post); }}
            >
              <div style={styles.likeButtonContainer}>
                <FaPaperPlane
                  size={'14px'}     // match your other icon sizing
                  color="white"
                  style={{ transform: 'scaleX(-1)' }} // flip horizontally
                />
              </div>
            </button>
            {post?.songSnippet && !post.imageUri && !post.media && (
              <button
                className="icon-button"
                style={{
                  opacity: (isPlaying || isVideoPlaying) && !!activeMedia?.contentId ? 0.5 : 1,
                  cursor: ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) ? 'default' : 'pointer',
                  background: 'transparent',
                  border: 'none',
                  padding: 0,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  if ((isPlaying || isVideoPlaying) && !!activeMedia?.contentId) return;
                  togglePreviewMuted(post);
                }}
              >
                <div className="like-button-container">
                  {previewMuted ? (
                    <IoVolumeMuteOutline
                      size={'18px'}
                      color="white"
                    />
                  ) : (
                    <IoVolumeHigh
                      size={'18px'}
                      color="white"
                    />
                  )}
                </div>
              </button>
            )}
                {post.mediaType === 'video' && (
                <div style={{ ...styles.iconButton, display: 'flex', alignItems: 'center' }}>
                  <FaEye size={14} color="white" style={{ marginRight: 6 }} />
                  <span style={styles.viewCountRight}>
                    {(post.viewCount || 0).toLocaleString()}
                  </span>
                </div>
              )}
        </div>
      </div>

        <div style={styles.commentSectionContainer}>
          {isSearchingComments && (
            <div style={styles.userSuggestionContainer}>
              {searchResultsComments.map(user => (
                <button style={{backgroundColor: 'transparent', border: 'none'}} key={user.id} onClick={() => handleSelectUser(user)}>
                  <span style={styles.userSuggestion}>{user.username}</span>
                </button>
              ))}
            </div>
          )}

          <div style={styles.addCommentContainer}>
            <textarea
              ref={commentInputRef}
              style={{ ...styles.commentInput, maxHeight: height * 0.1 }}
              onChange={handleTextChange}
              placeholder="Write a comment or @username..."
              value={comment}
              onSelect={(event) => {
                setSelection({ start: event.target.selectionStart, end: event.target.selectionEnd });
              }}
              placeholderTextColor="#b3b3b3"
            ></textarea>

            <button style={styles.commentButton} onClick={handleAddComment}>
              <span style={styles.commentButtonText}>Comment</span>
            </button>
          </div>
        </div>

        <div style={styles.commentsContainer}>
          <span style={styles.commentsHeading}>Comments</span>
          {comments.map((comment) => {
            const key = comment.commentId;
            return (
              <div key={key} style={styles.commentContainer}>
                <div style={styles.commentContentRow}>
                  <ProfilesDisplaySharePost userProfile={comment} onPress={() => fetchUserProfileByUserId(comment.userId)} />

                  <button
  style={styles.moreInfoButton}
  onClick={e => {
    e.stopPropagation();
    handleToggleOptions(comment, 'comment', post.postId);
  }}
>
                    <img src={ellipsis} style={{ width: '25px', height: '25px', backgroundColor: 'transparent', zIndex: '50000', pointerEvents: 'auto' }}></img>
                  </button>
                  {activeItemId && activeItemId.id === comment.commentId && activeItemId.type === 'comment' && renderOptions()}
                </div>
                <p style={styles.commentText}>
                  {Array.isArray(comment.text) ? comment.text.map((part, index) => {
                    if (part.type === 'tag') {
                      return (
                        <button key={index} onClick={() => fetchUserProfileByUserId(part.userId)}>
                          <span style={{ color: '#62fbfa' }}>{`@${part.username}`}</span>
                        </button>
                      );
                    } else {
                      return <span key={index}>{part.content}</span>;
                    }
                  }) : comment.text.split(/(\@\w+)/g).map((part, index) => {
                    if (part.startsWith('@') && comment.taggedUsers) {
                      const userTag = comment.taggedUsers.find(tag => `@${tag.username}` === part);
                      if (userTag) {
                        return (
                          <button style={{backgroundColor: 'transparent', border: 'none',}} key={index} onClick={() => fetchUserProfileByUserId(userTag.userId)}>
                            <span style={{ color: '#62fbfa', backgroundColor: 'transparent' }}>{part}</span>
                          </button>
                        );
                      }
                    }
                    return <span key={index}>{part}</span>;
                  })}
                </p>
                <button style={{backgroundColor: 'transparent', border: 'none', }} onClick={() => toggleRepliesVisibility(comment.commentId)}>
                  <span style={styles.repliesText}>Replies({comment?.replies?.length})</span>
                </button>
                {visibleReplies[comment.commentId] && (
                  <>
                    <div style={styles.userSuggestionContainer}>
                      {isSearchingReplies && searchResultsReplies.map(user => (
                        <button style={{backgroundColor: 'transparent', border: 'none'}} key={user.id} onClick={() => handleSelectUserForReply(user, comment.commentId)}>
                          <span style={styles.userSuggestion}>{user.username}</span>
                        </button>
                      ))}
                    </div>
                    <div style={styles.addReplyContainer}>
                      
                    <textarea
                      ref={replyInputRef}
                      style={{ ...styles.replyInput, maxHeight: height * 0.1 }}
                      value={replyTexts[comment.commentId] || ''}
                      onChange={(event) => handleReplyTextChange(event, comment.commentId)}
                      placeholder="Write a reply or @username..."
                      placeholderTextColor="#b3b3b3"
                      onSelect={(event) => setSelectionReplies({ [comment.commentId]: { start: event.target.selectionStart, end: event.target.selectionEnd } })}
                    ></textarea>
                    <button style={styles.replyButton}  onClick={() => onReplySubmit(comment.commentId)}>
                      <span style={styles.replyButton}>Reply</span>
                    </button>
                    </div>
                    {comment?.replies?.slice(0, 7).map((reply, index) => (
                      <div key={reply.replyId} style={styles.commentContainerReplies}>
                        <div style={styles.commentContentRow}>
                          <ProfilesDisplaySharePost userProfile={reply} onPress={() => fetchUserProfileByUserId(reply.userId)} />

                          <button style={styles.moreInfoButton} onClick={e => {
  e.stopPropagation();
  handleToggleOptions(reply, 'reply', post.postId, comment.commentId);
}}>
                    <img src={ellipsis} style={{ width: '25px', height: '25px', backgroundColor: 'transparent', zIndex: '50000', pointerEvents: 'auto' }}></img>
                  </button>
                  {activeItemId && activeItemId.id === reply.replyId     && activeItemId.type === 'reply'   && renderOptions()}
                        </div>
                        <p style={styles.commentText}>
                          {Array.isArray(reply.text) ? reply.text.map((part, i) => {
                            if (part.type === 'tag') {
                              return (
                                <button key={i} onClick={() => fetchUserProfileByUserId(part.userId)}>
                                  <span style={{ color: '#62fbfa' }}>{`@${part.username}`}</span>
                                </button>
                              );
                            } else {
                              return <span key={i}>{part.content}</span>;
                            }
                          }) : reply.text.split(/(\@\w+)/g).map((part, i) => {
                            if (part.startsWith('@') && reply.taggedUsers) {
                              const userTag = reply.taggedUsers.find(tag => `@${tag.username}` === part);
                              if (userTag) {
                                return (
                                  <button style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer', }} key={i} onClick={() => fetchUserProfileByUserId(userTag.userId)}>
                                    <span style={{ cursor: 'pointer', color: '#62fbfa', backgroundColor: 'transparent' }}>{part}</span>
                                  </button>
                                );
                              }
                            }
                            return <span key={i}>{part}</span>;
                          })}
                        </p>
                        <button style={{backgroundColor: 'transparent', border: 'none'}} onClick={() => initiateReplyToReply(reply, comment.commentId)}>
                          <span style={{ color: '#62fbfa', marginTop: 5, backgroundColor: 'transparent', border: 'none' }}>Reply</span>
                        </button>
                        {reply.isReplying && (
                          <>
                            <textarea
                              ref={textInputRef}
                              style={{ ...styles.replyInput, maxHeight: height * 0.1 }}
                              value={nestedReplyTexts[reply.replyId] || `@${reply.username} `}
                              onChange={(event) => handleReplyTextChangeReplies(event, reply.replyId)}
                              placeholder="Write a reply..."
                              placeholderTextColor="#b3b3b3"
                              autoFocus={true}
                            ></textarea>
                            <button style={{backgroundColor: 'transparent', border: 'none'}} onClick={() => onNestedReplySubmit(reply.replyId, comment.commentId)}>
                              <span style={styles.replyButton}>Submit Reply</span>
                            </button>
                          </>
                        )}
                      </div>
                    ))}
                    {comment?.replies?.length > 7 && (
                      <button >
                        <span style={styles.moreRepliesText}>More replies({comment?.replies?.length - 7})</span>
                      </button>
                    )}
                  </>
                )}
              </div>
            );
          })}
        </div>

        {modalVisible && (
          <div style={styles.fullScreenContainer}>
            <button style={{ ...styles.fullScreenContainer, activeOpacity: 1 }} onClick={() => setModalVisible(false)}>
              <img src={currentImage} style={styles.fullScreenImage} />
            </button>
          </div>
        )}

        {modalVisibleVideo && (
          <div style={styles.fullscreenVideo}>
            <video
              ref={videoRef}
              src={currentVideoUri}
              controls={true}
              style={{ resizeMode: 'contain' }}
              onFullscreenChange={handleFullscreenUpdate}
              onLoad={() => videoRef.current?.requestFullscreen().catch(error => console.error("Failed to enter fullscreen mode", error))}
              loop
            ></video>
            <div style={styles.controlButton}>
            </div>
          </div>
        )}

        {reportComplete && (
          <button style={styles.fullScreenOverlay} onClick={() => setReportComplete(false)}>
            <img src='./assets/DATBG.png' style={styles.fullScreenImage} />
            <span style={styles.overlayText}>Report Successful</span>
          </button>
        )}


      </div>
      <Modal
      isOpen={sharePostActive}
      onRequestClose={() => setSharePostActive(false)}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          zIndex: 10000,
        },
        content: {
          top: '30%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          height: '260px',
          width: '80%',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'transparent',
          padding: '20px',
          border: 'none',
          borderRadius: '8px',
        },
      }}
    >
      <div style={styles.sharingPost}>
      <ProfilesDisplayShareDATpost/>
      </div>
      <div style={styles.cancelContainer}>
      <button style={styles.cancelButton} onClick={() => setSharePostActive(false)}>Cancel</button>
      </div>
    </Modal>
    <Modal
      isOpen={showSharePostPopup}
      onRequestClose={() => setShowSharePostPopup(false)}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          zIndex: 10000,
        },
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          height: '400px',
          width: '95%',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'transparent',
          padding: '20px',
          border: 'none',
          borderRadius: '8px',
        },
      }}
    >
      <div style={styles.sharingPost}>
      <SharePostPopup/>
      </div>
      <div style={styles.cancelContainer}>
      <button style={styles.cancelButton} onClick={() => setShowSharePostPopup(false)}>Cancel</button>
      </div>
    </Modal>

    </div>
  );
};

const styles = {
  fullScreen: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'black',
  },
  extraSpace: {
    height: '300px',
      },
  sharingPost: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignSelf: 'center',
    justifyContent: 'center',
        },
        cancelContainer: {
    display: 'flex',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignSelf: 'center',
        },
        cancelButton: {
          padding: '10px 20px',
          marginBottom: '20px',
          display: 'flex',
          justifyContent: 'center',
          alignSelf: 'center',
          margin: '0 auto',
          position: 'absolute',
          bottom: '10px',
          backgroundColor: 'transparent',
          color: '#62fbfa',
          border: 'none',
          fontSize: '20px',
          borderRadius: '4px',
          cursor: 'pointer',
        },
  fullScreenOverlay: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10000,
  },
  overlayText: {
    color: 'white',
    fontSize: '20px',
    fontWeight: 'bold',
    position: 'absolute',
    textAlign: 'center',
    width: '100%',
  },
  replyInputContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: '5px',
  },
  iconButton: {
    paddingLeft: '20px',
    marginLeft: '-20px',
    paddingRight: '20px',
    marginRight: '-20px',
    marginBottom: '-10px',
    paddingBottom: '10px',
    paddingTop: '8px',
    marginTop: '-8px',
  },
  userSuggestionContainer: {
    backgroundColor: 'transparent',
    paddingVertical: '5px',
    paddingHorizontal: '10px',
    borderRadius: '5px',
    marginTop: '10px',
  },
  userSuggestion: {
    color: '#FFFFFF',
    padding: '10px',
    fontSize: '16px',
    borderWidth: '1px',
    backgroundColor: 'transparent',
    borderColor: '#CCCCCC',
    borderRadius: '5px',
    border: 'none',
    marginVertical: '2px',
  },
  replyInput: {
    flex: 1,
    backgroundColor: 'rgba(81, 33, 131, 0.5)',
    borderRadius: '20px',
    paddingHorizontal: '3%',
    paddingVertical: '1%',
    marginRight: '1%',
    border: 'none',
    resize: 'none',
    marginLeft: '2%',
    color: 'white',
    marginTop: '1%',
    fontSize: '16px'
  },
  replyButton: {
    backgroundColor: 'transparent',
    padding: '7px',
    justifyContent: 'center',
    alignSelf: 'center',
    border: 'none',
    fontFamily: 'brhendrix',
    fontSize: '14px',
    marginTop: '1%',
    color: 'white',
    alignSelf: 'center',
    cursor: 'pointer',
  },
  contentContainer: {
    paddingVertical: '17%',
  },
  commentsContainer: {
marginBottom: '50%',
  },
  buttonTouchableArea: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 1,
  },
  scrollContainer: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: 'calc(100% - 10vh)',
    zIndex: 10,
    overflow: 'visible',

  },
  popupImage: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    zIndex: 5,
  },
  likeButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    cursor: 'pointer',
  },
  postContainer: {
    padding: '7px',
    backgroundColor: "rgba(0,0,0,0.5)",
    borderRadius: '8px',
    border: '1px solid rgba(23, 195, 250, 0.5)', // Use shorthand property for border
    marginLeft: '10px',
    marginRight: '10px',
    zIndex: '500',
    position: 'relative',
    cursor: 'pointer',
  },
  postContainer2: {
    padding: '7px',
    backgroundColor: "rgba(0,0,0,0.5)",
    borderWidth: '1px',
    borderRadius: '8px',
    border: '1px solid rgba(23, 195, 250, 0.5)',
    marginLeft: '10px',
    marginRight: '10px',
    marginBottom: '20px',
    cursor: 'pointer',
  },
  contentRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    zIndex: 10,
  },
  timeAgoStyle: {
    color: 'white',
    fontSize: '14px',
    flexShrink: 1,
    right: 50,
    position: 'relative',
    marginBottom: '15px',
    justifyContent: 'center',
    alignSelf: 'center',
    paddingHorizontal: '5px',
    paddingBottom: '21px',
  },
  postText: {
    marginTop: '5%',
    marginLeft: '5%',
    marginBottom: '1.8%',
    marginRight: '5%',
    color: 'white',
    fontSize: '18px',
    fontFamily: 'brhendrix',
  },
  postText2: {
    marginTop: '5%',
    marginLeft: '5%',
    marginRight: '5%',
    marginBottom: '1.5%',
    color: 'white',
    fontSize: '18px',
    fontFamily: 'brhendrix',
  },
  postTextNoImage: {
    marginTop: '-2%',
    marginLeft: '23%',
    marginBottom: '1.8%',
    marginRight: '5%',
    color: 'white',
    fontSize: '18px',
    fontFamily: 'brhendrix',
  },
  iconImage: {
    width: '5%',
    height: '5%',
  },
  iconsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    bottom: '0.5%',
  },
  likeCount: {
    color: 'white',
    fontSize: '3%',
  },
  commentContainer: {
    backgroundColor: 'rgba(0,0,0,0.5)',
    borderRadius: '8px',
    borderWidth: '1px',
    borderColor: 'rgba(23, 195, 250, 0.5)',
    padding: '10px',
    marginLeft: '15px',
    marginHorizontal: '10px',
    marginBottom: '5px',
  },
  commentContainerReplies: {
    backgroundColor: 'rgba(0,0,0,0.5)',
    borderRadius: '8px',
    borderWidth: '1px',
    borderColor: 'rgba(23, 195, 250, 0.5)',
    padding: '10px',
    marginHorizontal: '10px',
    marginBottom: '5px',
    marginTop: '1%',
  },
  commentContentRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '0.8%',
    position: 'relative',
  },
  commentsHeading: {
    fontSize: '20px',
    fontWeight: 'bold',
    marginLeft: '2.7%',
    marginBottom: '1%',
    color: 'white',
  },
  commentItem: {
    marginBottom: '1%',
  },
  commentText: {
    color: 'white',
    fontSize: '18px',
    marginTop: '-2%',
    fontFamily: 'brhendrix',
    marginLeft: '2%',
  },
  addCommentContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '2%',
    marginTop: '2%',
  },
  addReplyContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '2%',
    marginTop: '2%',
  },
  commentInput: {
    flex: 1,
    backgroundColor: 'rgba(81, 33, 131, 0.5)',
    borderRadius: '20px',
    border: 'none',
    resize: 'none',
    paddingHorizontal: '3%',
    paddingVertical: '1%',
    marginRight: '1%',
    marginLeft: '4%',
    fontSize: '16px',
    paddingLeft: '10px',
    paddingTop: '2%',

    color: 'white',
  },
  commentButton: {
    borderRadius: '28px',
    paddingHorizontal: '16px',
    paddingTop: '12px',
    paddingBottom: '12px',
    marginRight: '4%',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
  commentButtonText: {
    color: 'white',
    fontSize: '14px',
    fontFamily: 'brhendrix',
    fontWeight: 'bold',
  },
  nestedCommentContainer: {
    backgroundColor: 'rgba(0,0,0,0.5)',
    borderRadius: '8px',
    borderWidth: '1px',
    borderColor: 'rgba(23, 195, 250, 0.5)',
    padding: '10px',
    marginHorizontal: '20px',
    marginBottom: '5px',
  },
  postImage: {
    width: '100%',
    height: '30vh',
    alignSelf: 'center',
    marginTop: '1%',
    marginBottom: '2%',
    resizeMode: 'contain',
    
  },
  optionsContainer: {
    position: 'absolute',
    right: 20,
    display: 'flex',
    flexDirection: 'column',
    top: 25,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    borderRadius: '5px',
    padding: '5px',
    marginRight: '5%',
  },
  optionText: {
    color: 'white',
    padding: '5px',
    fontFamily: 'brhendrix',
  },
  repliesText: {
    color: 'white',
    marginLeft: '20px',
    fontFamily: 'brhendrix',
    marginTop: '1.6%',
  },
  moreRepliesText: {
    color: 'white',
    marginLeft: '20px',
    marginBottom: '10px',
    fontFamily: 'brhendrix',
    cursor: 'pointer',
  },
  fullScreenContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'black',
  },
  fullScreenImage: {
    width: '100%',
    height: '100%',
    resizeMode: 'contain',
  },
  fullscreenVideo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#000',
  },
  controlButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  deleteButton: {
    color: 'red',
  },
  mediaContainer2: {
    width: '100%',
    height: '27vh',
    overflow: 'hidden',
    borderRadius: '2%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'black',
    border: 'none',
  },
  mediaThumbnail2: {
    width: '100%',
    height: '120%',
    resizeMode: 'cover',
  },
  additionalMargin: {
    marginBottom: '2.3%',
  },
  playIcon: {
    position: 'absolute',
    width: '6.8%',
    height: '8%',
    alignSelf: 'center',
  },
  mediaContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '1%',
    backgroundColor: 'transparent',
    overflow: 'hidden',
    borderRadius: '10px',
    border: 'none',
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '1%',
    overflow: 'hidden',
    backgroundColor: 'transparent',
    borderRadius: '10px',
    marginBottom: '2%',
  },
  postContainer: {
    padding: '7px',
    backgroundColor: "rgba(0,0,0,0.5)",
    borderRadius: '8px',
    border: '1px solid rgba(23, 195, 250, 0.5)', // Use shorthand property for border
    marginLeft: '10px',
    marginRight: '10px',
    zIndex: 10,
  },

activityIndicator: {
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)'
},
controlButton: {
  position: 'absolute',
  top: '20px',
  right: '20px',
  padding: '10px'
},
iconButton: {
  paddingLeft: '20px',
  marginLeft: '-20px',
  paddingRight: '20px',
  marginRight: '-20px',
  marginBottom: '-10px',
  paddingBottom: '10px',
  paddingTop: '8px',
  marginTop: '-8px',
  backgroundColor: 'transparent',
  border: 'none',
},
iconButtonLike: {
  paddingLeft: '20px',
  marginLeft: '-20px',
  paddingRight: '20px',
  marginRight: '-20px',
  marginBottom: '-10px',
  paddingBottom: '10px',
  paddingTop: '8px',
  marginTop: '-8px',
  backgroundColor: 'transparent',
  border: 'none',
  // Any other styles you want to apply to the touchable opacity
},

likeButtonContainer: {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  backgroundColor: 'transparent',
  cursor: 'pointer',
},
iconImage: {
  width: '16px',
  height: '16px',
  marginRight: '5px',
  backgroundColor: 'transparent',
  
},
likeCount: {
  color: 'white',
  fontSize: '16px',
},
postContainer: {
  padding: '7px',
  backgroundColor: "rgba(0,0,0,0.5)",
  borderRadius: '8px',
  border: '1px solid rgba(23, 195, 250, 0.5)', // Use shorthand property for border
  marginLeft: '10px',
  marginRight: '10px',
  zIndex: '500',
  position: 'relative',
  cursor: 'pointer',
},
postContainer2: {
  padding: '7px',
  backgroundColor: "rgba(0,0,0,0.5)",
  borderWidth: '1px',
  borderRadius: '8px',
  border: '1px solid rgba(23, 195, 250, 0.5)',
  marginLeft: '10px',
  marginRight: '10px',
  marginBottom: '20px',
  cursor: 'pointer',
},
postText: {
  marginTop: '20px',
  marginLeft: '20px',
  marginBottom: '18px',
  marginRight: '20px',
  color: 'white',
  fontSize: '18px',
  fontFamily: 'brhendrix',
},
postText2: {
  marginTop: '20px',
  marginLeft: '20px',
  marginRight: '20px',
  marginBottom: '15px',
  color: 'white',
  fontSize: '18px',
  fontFamily: 'brhendrix',
},
postTextNoImage: {
  marginTop: '-8px',
  marginLeft: '50px',
  marginBottom: '18px',
  marginRight: '20px',
  color: 'white',
  fontSize: '16px',
  fontFamily: 'brhendrix',
},
postImage: {
  width: '100%',
  height: '300px',
  backgroundColor: 'transparent',
  alignSelf: 'center',
  marginTop: '10px',
  marginBottom: '20px',
  objectFit: 'contain',
},
fullScreen: {
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  overflow: 'hidden',
  position: 'relative',
  overflowY: 'scroll',
  marginTop: '10px',
},
scrollContainer2: {
  position: 'relative',
  width: '100%',
  height: '100%',
  zIndex: 2,
  listStyleType: 'none',
  padding: 0,
  overflowY: 'scroll', // Ensure vertical scrolling
},
scrollContainer: {
  position: 'relative',
  width: '100%',
  height: '100%',
  paddingBottom: '200px',
  zIndex: 3,
  overflowY: 'scroll', // Ensure vertical scrolling
},
iconsContainer: {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-evenly',
  alignItems: 'center',
  marginBottom: '5px',
},
moreInfoButton: {
  marginLeft: 'auto',
  marginBottom: '20px',
  width: '50px',
  pointerEvents: 'auto',
  height: '100%',
  padding: '10px',
  border: 'none',
  backgroundColor: 'transparent',
  zIndex: '50000',
  position: 'relative',
  cursor: 'pointer',
},
contentRow: {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  flex: 1,
},
timeAgoStyle: {
  color: 'white',
  fontSize: '14px',
  flexShrink: 1,
  right: 50,
  position: 'relative',
  marginBottom: '15px',
  justifyContent: 'center',
  alignSelf: 'center',
  paddingHorizontal: '5px',
  paddingBottom: '21px',
},
buttonTouchableArea: {
  position: 'absolute',
  width: '100%',
  height: '100%',
  zIndex: 1,
},
optionsContainer: {
  position: 'absolute',
  right: 20,
  display: 'flex',
  flexDirection: 'column',
  top: '9px',
  backgroundColor: 'rgba(0, 0, 0, 0.8)',
  borderRadius: '5px',
  padding: '5px',
  marginRight: '5%',
  zIndex: 10000,
},
fullscreenVideo: {
  width: '100%',
  height: '100%',
  backgroundColor: '#000',
},
modal: {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.8)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
},
closeButton: {
  position: 'absolute',
  top: '20px',
  right: '20px',
  padding: '10px',
  backgroundColor: 'white',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer',
},
tagContainer: {
  display: 'inline',
  cursor: 'pointer',
},
playIcon: {
  position: 'absolute',
  width: '68px',
  height: '80px',
  alignSelf: 'center',
},
fullScreenOverlay: {
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 10000,
},
fullScreenImage: {
  width: '100%',
  height: '100%',
  objectFit: 'contain',
},
overlayText: {
  color: 'white',
  fontSize: '20px',
  fontWeight: 'bold',
  position: 'absolute',
  textAlign: 'center',
  width: '100%',
},
imageContainer: {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '10px',
  overflow: 'hidden',
  borderRadius: '10px',
  backgroundColor: 'transparent',
  border: 'none',
  marginBottom: '20px',
},
mediaContainer: {
  display: 'flex', 
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
  borderRadius: '10px',
  border: 'none',
  objectFit: 'contain',
  backgroundColor: 'transparent',
  zIndex: 500,
  border: 'none',
},
mediaContainer2: {
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  borderRadius: '20px',
  
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'black',
  zIndex: 500,
  border: 'none',
},
mediaThumbnail2: {
  width: '100%',
  height: '120%',
  objectFit: 'cover',
},
mediaContainer: {
  display: 'flex', 
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
  borderRadius: '10px',
  objectFit: 'contain',
  zIndex: 500,
},
mediaContainer2: {
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  borderRadius: '20px',
  display: 'flex',
  marginBottom: '20px',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'black',
  zIndex: 500,
  
},
mediaThumbnail2: {
  width: '100%',
  height: '120%',
  objectFit: 'cover',
},

songSnippetRow: {
  flexDirection: 'row',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '6px 8px',
  margin: '6px 0 4px',
  marginTop: '-48px',
    marginBottom: '10px',
  marginLeft: '42px',
},
songMuteBtn: {
  width: 22,
  height: 22,
  borderRadius: 22,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(255,255,255,0.18)',
},
songIconBtn: {
  width: 10,
  height: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
},
songSnippetText: {
  color: '#FFFFFF',
  fontSize: 12,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '86%',
},
viewCountRight: {
  color: '#FFFFFF',
  fontSize: 12,
},

mediaContainer2: {
  position: 'relative',               // needed for overlay buttons
},

};

export default ViewPostScreen;
